import { isEmpty } from "react-redux-firebase";
import {
    LOADING_SCREEN_HIDE, LOADING_SCREEN_SHOW, RESET_CLAIM_DATA, SET_CLAIM_DATA, SET_CUSTOMER_DATA,
    MODAL_HIDE, MODAL_SHOW, MODAL_TYPE_ERROR, MODAL_TYPE_SUCCESS, CLAIM_TYPE_GLASS, THIRDPARTY_TYPE_OTHER_ID, MODAL_TYPE_CONFIRM_INCIDENT_AND_RISK,
    SET_STEPS_GLASS, SET_STEPS_DRIVABLE, SET_STEPS_DRIVABLE_STATIONARY, SET_STEPS_CELLPHONE, SET_STEPS_CELLPHONE_OTHER, SET_STEPS_FNOL, SET_STEPS_CLAIMS_WARRANTY,
    CLAIM_SCRATCH_AND_DENT_TEMPLATE_ID, CLAIM_TYRE_AND_RIM_TEMPLATE_ID, CLAIM_LITTLE_DINGS_TEMPLATE_ID, CLAIM_WARRANTY_TEMPLATE_ID, CLAIM_THIRD_PARTY_INSURED_YES, CLAIM_THIRD_PARTY_INSURED_NO, CLAIM_THIRD_PARTY_INSURED_NOT_SURE,
    CLAIM_INCIDENT_TYPE_ANIMAL, CLAIM_DAMAGE_CAUSE_ANIMAL,
    CLAIM_INCIDENT_TYPE_POTHOLE, CLAIM_DAMAGE_CAUSE_POTHOLE,
    CLAIM_INCIDENT_TYPE_PEDESTRIAN, CLAIM_DAMAGE_CAUSE_PEDESTRIAN,
    CLAIM_INCIDENT_TYPE_SINGLE_VEHICLE_STATIONARY, CLAIM_DAMAGE_CAUSE_SINGLE_VEHICLE_STATIONARY,
    CLAIM_INCIDENT_TYPE_MULTI_VEHICLE_STATIONARY, CLAIM_DAMAGE_CAUSE_MULTI_VEHICLE_STATIONARY,
    CLAIM_INCIDENT_TYPE_SINGLE_VEHICLE_DRIVEN, CLAIM_DAMAGE_CAUSE_SINGLE_VEHICLE_DRIVEN,
    CLAIM_INCIDENT_TYPE_TYRE_BURST, CLAIM_DAMAGE_CAUSE_TYRE_BURST,
    CLAIM_INCIDENT_TYPE_TRACK_INCIDENT_MOTOR, CLAIM_INCIDENT_TYPE_TRACK_INCIDENT_MOTORBIKE, CLAIM_DAMAGE_CAUSE_TRACK_INCIDENT,
} from "../constants/constants";
import { logErrorToDatabase, postToController } from "./apiActions";
import { isMobile } from "react-device-detect";
import { ERROR_HEADER, ERROR_INSPECTION_PHOTOS, ERROR_SOMETHING_WENT_WRONG } from "../constants/copy";
import { IThirdParty, IThirdPartyConfig, IThirdPartyToClaim } from "../interfaces/ThirdParty/ThirdPartyInterface";
import { CLAIM_END_PAGE, DASHBOARD, FNOL_SUBMIT_CLAIM } from "../routes/routes";
import { showClaimsAddressChange, showContinueOnPhone, showInspectionContinueOnPhone, showModalClearParty } from "./modalActions";
import { showModalDrivabeSuccessSubmittedFollowUp, showModalDrivableCloseClaim } from './modalCallbackActions';
import { navigateTo } from "./navigationActions";
import { THIRDPARTY_TYPE_OTHER, THIRDPARTY_TYPE_WITNESS, THIRDPARTY_TYPE_PEDESTRIAN, THIRDPARTY_TYPE_PASSENGER } from "../constants/constants";
import { CAR_CLAIM_VAPS_DINGS_AND_THINGS_ID, CAR_CLAIM_VAPS_TYRE_AND_RIM_ID, CHILLI_COMPREHENSIVE_PRODUCT_ID, MOTOR_COMPREHENSIVE_PRODUCT_ID } from "../constants/products";
import { AddUpdateCarDamageOnClaim, AddUpdateClaimMessage, AddUpdateMotorBikeDamageOnClaim, DriverDetail, ClaimLocation, ClaimantDetail, CreateIncident, DrivableClaimRequest, InitiateClaim, MobileBlingClaimRequest, RegularDriverDropdownItem, AddTraumaCounsellingRequest } from "../interfaces/Claims/claimsInterfaces";
import { hideLoadingScreen, showLoadingScreen } from "./fullscreenActions";
import { validateEmail, validateName, validateSurname, validateCellphoneNumber, validateIdNumber } from '../constants/validation';
import { logEvent } from "../firebase/firebase";

export const setClaimData = (payload) => {
    return (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: payload
        });
    }
}

//#region generalClaims
export const getCustomerClaims = () => {
    return async (dispatch, getState) => {
        var result = false;
        await postToController(dispatch, 'GetCustomerClaims',
            JSON.stringify({ CustomerId: getState().profile.customerId, PolicyId: getState().profile.policyId }))
            .then(async (response) => {
                try {
                    if (!isEmpty(response) && response !== "") {
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                personalClaims: response,
                            }
                        });
                        result = true;
                    }
                } catch (err) {
                    logErrorToDatabase("Error in getCustomerClaims, Error: " + err);
                }
            });

        return result;
    };
}

export const checkDuplicateClaim = (data) => {
    return async (dispatch, getState) => {
        var functionResponse = false;

        await dispatch({ type: LOADING_SCREEN_SHOW });
        try {
            await postToController(dispatch, 'DuplicateClaimCheck',
                data).then(async (response) => {
                    if (response.isDuplicate) {
                        await dispatch(getCustomerClaims());
                        let claim = getState().profile.personalClaims.filter(function (item) {
                            return item.claimNumber === response.claimsResponse.claimNumber
                        })
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                selectedPersonalClaim: claim[0],
                            }
                        });
                    }
                    functionResponse = response.isDuplicate;
                })
        } catch (err) {
            logErrorToDatabase("Error in DuplicateClaimCheck, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const checkDuplicateClaimDrivable = (data) => {
    return async (dispatch, getState) => {
        var functionResponse = false;

        await dispatch({ type: LOADING_SCREEN_SHOW });
        try {
            await postToController(dispatch, 'DuplicateClaimCheckDrivable', data)
                .then(async (response) => {
                    if (response.isDuplicate) {
                        await dispatch(getCustomerClaims());
                        let claims = getState().profile.personalClaims?.filter(item => item.claimNumber === response.claimsResponse.claimNumber);
                        let claim = claims.length > 0 ? claims[0] : null;
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                selectedPersonalClaim: claim,
                            }
                        });
                    }
                    functionResponse = response.isDuplicate;
                });
        } catch (err) {
            logErrorToDatabase("Error in DuplicateClaimCheck, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const setTime = (f12, f24) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                time: f24,
                timeDisplay: f12
            }
        });
    }
}

export const setCover = (userData) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                selectedCover: userData,
            }
        });
    }
}

export const setIncidentEventList = (ListData, Event) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                incidentEventList: ListData,
                incidentEventType: Event
            }
        });
    }
}

export const setIncidentEvent = (Event) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                incidentType: Event
            }
        });
    }
}

export const setTimeShow = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                IsIncidentDateClicked: !getState().claimSubmit.IsIncidentDateClicked,
            }
        });
    }
}

export const submitClaim = (userData: any) => {
    return async (dispatch, getState) => {
        var functionResponse = false;
        var customerId = getState().profile.customerId;
        var recovered = userData.isRecovered
        var driveable = userData.isDriveable
        if (getState().claimSubmit.selectedCover.product !== MOTOR_COMPREHENSIVE_PRODUCT_ID || getState().claimSubmit.selectedCover.product !== CHILLI_COMPREHENSIVE_PRODUCT_ID) {
            recovered = false;
            driveable = false;
        }
        await dispatch({ type: LOADING_SCREEN_SHOW });
        logEvent('SSP_submit_fnol', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        try {
            await postToController(dispatch, 'SubmitFNOLClaim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentEventType: getState().claimSubmit.selectedEvent.id,
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.time,
                    IncidentDescription: userData.incidentDescription,
                    IsRecovered: recovered,
                    IsDrivable: driveable,
                    ContactPersonName: userData.name,
                    ContactPersonNumber: userData.contact,
                    Lat: getState().claimSubmit.lat,
                    Lng: getState().claimSubmit.lon,
                    IncidentLocationAddressLine1: getState().claimSubmit.address,
                    IncidentLocationAddressLine2: "",
                    IncidentLocationCity:getState().claimSubmit.addressDetail.city,
                    IncidentLocationSuburb:getState().claimSubmit.addressDetail.suburb,
                    IncidentLocationPostalCode:getState().claimSubmit.addressDetail.postalCode,
                    IncidentLocationProvince:getState().claimSubmit.addressDetail.province,
                    CustomerId: customerId,
                    IncidentType: getState().claimSubmit.incidentType.id
                })).then(async (response) => {
                    await dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            claimNumber: response.result.claimNumber,
                            isFnolClaim: true,
                        }
                    });
                    await dispatch(getCustomerClaims());
                    let claim = getState().profile.personalClaims.filter(function (item) {
                        return item.claimNumber === response.result.claimNumber
                    })
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            selectedPersonalClaim: claim[0],
                        }
                    });
                    await dispatch({
                        type: RESET_CLAIM_DATA, payload: {
                        }
                    });
                    functionResponse = true;
                })
        } catch (err) {
            logErrorToDatabase("Error in SubmitFNOLClaim, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const submitClaimMobile = (userData: any) => {
    return async (dispatch, getState) => {
        var customerId = getState().profile.customerId;
        var functionResponse = false;
        var recovered = userData.isRecovered
        var driveable = userData.isDriveable
        if (getState().claimSubmit.selectedCover.product !== 1 || getState().claimSubmit.selectedCover.product !== 7) {
            recovered = false;
            driveable = false;
        }
        logEvent('SSP_submit_fnol_mobile', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        await dispatch({ type: LOADING_SCREEN_SHOW });
        try {
            await postToController(dispatch, 'SubmitFNOLClaim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentEventType: getState().claimSubmit.selectedEvent.id,
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.time,
                    IncidentDescription: userData.incidentDescription,
                    IsRecovered: recovered,
                    IsDrivable: driveable,
                    ContactPersonName: userData.name,
                    ContactPersonNumber: userData.contact,
                    Lat: getState().claimSubmit.lat,
                    Lng: getState().claimSubmit.lon,
                    IncidentLocationAddressLine1: getState().claimSubmit.address,
                    IncidentLocationAddressLine2: "",
                    IncidentLocationCity:getState().claimSubmit.addressDetail.city,
                    IncidentLocationSuburb:getState().claimSubmit.addressDetail.suburb,
                    IncidentLocationPostalCode:getState().claimSubmit.addressDetail.postalCode,
                    IncidentLocationProvince:getState().claimSubmit.addressDetail.province,
                    AddressLine1: getState().claimSubmit.address,
                    CustomerId: customerId,
                    IncidentType: getState().claimSubmit.incidentType.id
                })).then(async (response) => {
                    await dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            claimNumber: response.result.claimNumber,
                            isFnolClaim: true,
                        }
                    });
                    await dispatch(getCustomerClaims());
                    let claim = getState().profile.personalClaims.filter(function (item) {
                        return item.claimNumber === response.result.claimNumber
                    })
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            selectedPersonalClaim: claim[0],
                        }
                    });
                    await dispatch({
                        type: RESET_CLAIM_DATA, payload: {
                        }
                    });
                    functionResponse = true;
                })
        } catch (err) {
            logErrorToDatabase("Error in SubmitFNOLClaim, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const refreshCustomerClaims = () => {
    return async (dispatch, getState) => {
        var claimID = getState().claimSubmit.claimId;
        await dispatch(getCustomerClaims());
        let claim = getState().profile.personalClaims.filter(function (item) {
            return item.claimID === claimID
        })
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                selectedPersonalClaim: claim[0],
            }
        });
    }
}

export const submitClaimV2 = () => {
    return async (dispatch, getState) => {
        var functionResponse = false;
        await dispatch({ type: LOADING_SCREEN_SHOW });
        try {
            await postToController(dispatch, 'SubmitclaimV2Claim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentEventType: getState().claimSubmit.incidentType.id,
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.incidentTime,
                    IncidentDescription: getState().claimSubmit.incidentDescription,
                    IsRecovered: true,
                    IsDrivable: getState().claimSubmit.isDriveavle,
                    ContactPersonName: getState().claimSubmit.contactName,
                    ContactPersonNumber: getState().claimSubmit.contactNumber,
                    Lat: getState().claimSubmit.lat,
                    Lng: getState().claimSubmit.lon
                })).then(async (response) => {
                    if (response !== "Failure") {

                        await dispatch({
                            type: SET_CLAIM_DATA, payload: {
                                claimNumber: response.result.claimNumber,
                            }
                        });
                        await dispatch(getCustomerClaims());
                        let claim = getState().profile.personalClaims.filter(function (item) {
                            return item.claimNumber === response.result.claimNumber
                        })
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                selectedPersonalClaim: claim[0],
                            }
                        });
                        functionResponse = true;
                    }
                    else {
                        await dispatch(navigateTo(DASHBOARD));

                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                    }
                })
        } catch (err) {
            logErrorToDatabase("Error in SubmitclaimV2Claim, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const submitClaimV2NotDriveable = () => {
    return async (dispatch, getState) => {
        var functionResponse = false;

        await dispatch({ type: LOADING_SCREEN_SHOW });
        try {
            await postToController(dispatch, 'SubmitclaimV2Claim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentEventType: getState().claimSubmit.incidentType.id,
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.incidentTime,
                    IncidentDescription: getState().claimSubmit.incidentDescription,
                    IsRecovered: true,
                    IsDrivable: false,
                    ContactPersonName: getState().claimSubmit.contactName,
                    ContactPersonNumber: getState().claimSubmit.contactNumber,
                    Lat: getState().claimSubmit.lat,
                    Lng: getState().claimSubmit.lon
                })).then(async (response) => {
                    await dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            claimNumber: response.result.claimNumber,
                        }
                    });
                    await dispatch(getCustomerClaims());
                    let claim = getState().profile.personalClaims.filter(function (item) {
                        return item.claimNumber === response.result.claimNumber
                    })
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            selectedPersonalClaim: claim[0],
                        }
                    });
                    functionResponse = true;
                })
        } catch (err) {
            logErrorToDatabase("Error in SubmitclaimV2Claim, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const submitclaimV2AndPhoto = () => {
    return async (dispatch, getState) => {
        var functionResponse = false;

        await dispatch({ type: LOADING_SCREEN_SHOW });
        try {
            await postToController(dispatch, 'SubmitclaimV2Claim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentEventType: getState().claimSubmit.incidentType.id,
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.incidentTime,
                    IncidentDescription: getState().claimSubmit.incidentDescription,
                    IsRecovered: true,
                    IsDrivable: getState().claimSubmit.isDriveavle,
                    ContactPersonName: getState().claimSubmit.contactName,
                    ContactPersonNumber: getState().claimSubmit.contactNumber,
                    Lat: getState().claimSubmit.lat,
                    Lng: getState().claimSubmit.lon
                })).then(async (responseSubmit) => {
                    await postToController(dispatch, 'SubmitclaimV2PhotoBatchUpload',
                        JSON.stringify({
                            ClaimId: responseSubmit.result.claimId,
                            RiskItem: getState().claimSubmit.selectedRiskItem.riskItems[0].riskItemId,
                        })).then(async (responsePhoto) => {
                            for (var i = 0; i < getState().claimSubmit.claimDamagePhotoTypes.length; i++) {
                                if (getState().claimSubmitclaimDamagePhotoTypes[i].isSelected) {
                                    var isLastPhoto = true;
                                    if (responseSubmit !== null) {
                                        for (var k = i + 1; k < getState().claimSubmit.claimDamagePhotoTypes.length; k++) {
                                            if (getState().claimSubmitclaimDamagePhotoTypes[k].isSelected) {
                                                isLastPhoto = false;
                                            }
                                        }
                                        if (getState().claimSubmitclaimDamagePhotoTypes[i].photoData !== "") {
                                            await postToController(dispatch, 'SubmitclaimV2Photo',
                                                JSON.stringify({
                                                    Data: getState().claimSubmit.claimDamagePhotoTypes[i].photoData,
                                                    RiskItemId: getState().claimSubmit.selectedRiskItem.riskItems[0].riskItemId,
                                                    PolicyId: getState().profile.selectedPersonalCover.id,
                                                    IsLast: isLastPhoto,
                                                    RiskItemType: 1,
                                                    PhotoType: getState().claimSubmit.claimDamagePhotoTypes[i].id,
                                                    PhotoBatchId: responsePhoto.photoBatchId
                                                }))
                                                .then(async response => {

                                                })
                                                .catch(err => logErrorToDatabase("Self inspection photo upload error:: " + err))
                                        }
                                    } else {
                                        await dispatch(navigateTo(DASHBOARD));
                                        dispatch({
                                            type: MODAL_SHOW,
                                            modalProps: {
                                                type: MODAL_TYPE_ERROR,
                                                header: ERROR_HEADER,
                                                body: ERROR_SOMETHING_WENT_WRONG,
                                            }
                                        });
                                        break;
                                    }
                                }
                            }
                            await dispatch({
                                type: SET_CLAIM_DATA, payload: {
                                    claimNumber: responseSubmit.result.claimNumber,
                                }
                            });
                            await dispatch(getCustomerClaims());
                            let claim = getState().profile.personalClaims.filter(function (item) {
                                return item.claimNumber === responseSubmit.result.claimNumber
                            })
                            await dispatch({
                                type: SET_CUSTOMER_DATA, payload: {
                                    selectedPersonalClaim: claim[0],
                                }
                            });
                            functionResponse = true;
                        })
                })
        }
        catch (err) {
            logErrorToDatabase("Error in SubmitclaimV2Claim, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const scrollToScrollClass = () => {
    if (document.getElementsByClassName('scrollclass').length) {
        document.getElementsByClassName('scrollclass')[0].scrollIntoView({ behavior: "smooth" })
    }
}

export const setContinueOnPhone = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                continueOnMobile: true
            }
        });
    }
}

export const sendSMS = (phoneNumber: string) => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'SendContinueSms',
            JSON.stringify({
                Parameter: phoneNumber,
            })
        ).catch(err => logErrorToDatabase("Error sending sms: " + err))
    }
}

export const logContinueOnPhone = () => {
    return async (dispatch, getState) => {

        await postToController(dispatch, 'LogContinueOnPhone',
            JSON.stringify({
                CustomerId: getState().profile.customerId,
                RiskItemId: getState().claimSubmit.selectedRiskItem.id,
                IncidentTypeId: getState().claimSubmit.incidentType.id,
            }))
            .then(async response => {
                dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            })
            .catch(err => logErrorToDatabase("Error logging claim continue: " + err))
    }
}

export const removeNotifyFlag = () => {
    return async (dispatch, getState) => {

        await postToController(dispatch, 'RemoveContinueCheck',
            JSON.stringify({
                Parameter: getState().profile.customerId,
            }))
            .then(async response => {
                dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            })
            .catch(err => logErrorToDatabase("RemoveContinueCheck Error: " + err))
    }
}

export const checkContinueAndSetData = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'CheckContinueOnPhone',
            JSON.stringify({
                Parameter: getState().profile.customerId,
            }))
            .then(async retrieveResponse => {
                if (retrieveResponse) {
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            showMobileProfile: false,
                        }
                    });
                    await dispatch(showContinueOnPhone())
                }
            })
            .catch(err => logErrorToDatabase("CheckContinueOnPhone Error: " + err))

        await postToController(dispatch, 'CheckSelfInspectionContinueOnPhone',
            JSON.stringify({
                Parameter: getState().profile.customerId,
            }))
            .then(async retrieveResponse => {
                if (retrieveResponse) {
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            showMobileProfile: false,
                        }
                    });
                    await dispatch(showInspectionContinueOnPhone())
                }
            })
            .catch(err => logErrorToDatabase("CheckSelfInspectionContinueOnPhone Error: " + err))
    }
}

export const getContinueAndSetData = () => {
    return async (dispatch, getState) => {
        await dispatch({ type: LOADING_SCREEN_SHOW });

        await postToController(dispatch, 'GetClaimDataAndRemoveCheck',
            JSON.stringify({
                Parameter: getState().profile.customerId,
            }))
            .then(async dataResponse => {
                dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });

                var policies = getState().profile.selectedPersonalPolicy;
                var selectedCover = [];
                var selectedCoverId = "";
                var selectedCoverProduct = 0;
                var selectedIncident = [];
                var selectedIncidentId = 0;
                if (policies !== undefined) {
                    for (var i = 0; i < policies.covers.length; i++) {
                        var cover = policies.covers[i];
                        if (cover.id === dataResponse.riskItemId) {
                            selectedCover = cover;
                            selectedCoverId = cover.id
                            selectedCoverProduct = cover.product
                            break;
                        }
                    };

                    await postToController(dispatch, 'GetEventTypes', JSON.stringify({ Parameter: selectedCoverId })).then(async (response) => {
                        for (var j = 0; j < response.length; j++) {
                            var incident = response[j];
                            if (incident.id == dataResponse.incidentTypeId) {
                                selectedIncident = incident;
                                selectedIncidentId = incident.id
                                break;
                            }
                        };
                    })

                    await postToController(dispatch, 'GetIncidentTypesByIncidentEventTypeId', JSON.stringify({ Parameter: selectedIncidentId })).then(async (responseList) => {
                        await dispatch({
                            type: SET_CLAIM_DATA, payload: {
                                selectedPersonalCover: selectedCover,
                                IncidentType: selectedIncident,
                                fnolStep: 1,
                                fnolSubStep: 4,
                                incidentEventList: responseList,
                                isCar: (selectedCoverProduct === 1)
                            }
                        });
                    })

                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            showMobileProfile: false,
                        }
                    });
                    await dispatch(navigateTo(FNOL_SUBMIT_CLAIM));
                }
            })
            .catch(err => logErrorToDatabase("GetClaimDataAndRemoveCheck Error: " + err))
        await dispatch({ type: LOADING_SCREEN_SHOW });
    }
}

export const getClaimDamagePhotoTypes = (riskItemType: number) => {
    return async (dispatch, getState) => {
        if (getState().claimSubmit.claimType === CLAIM_TYPE_GLASS) {
            await postToController(dispatch, 'GetGlassClaimDamagePhotoTypes',
                JSON.stringify({
                }))
                .then(async response => {
                    await dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            claimDamagePhotoTypes: response
                        }
                    });
                })
                .catch(err => logErrorToDatabase("GetGlassClaimDamagePhotoTypes Error: " + err))
        }
        else {
            await postToController(dispatch, 'GetClaimDamagePhotoTypes',
                JSON.stringify({
                    Parameter: riskItemType
                }))
                .then(async response => {
                    await dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            claimDamagePhotoTypes: response
                        }
                    });
                })
                .catch(err => logErrorToDatabase("GetClaimDamagePhotoTypes Error: " + err))
        }
    }
}

export const setSelectedDamagePhotoTypes = (selectedDamagePhotoType: any) => {

    return async (dispatch, getState) => {
        var prev = getState().claimSubmit.selectedDamagePhotoTypes;
        var next = [];
        if (prev.length == 0) {
            next = selectedDamagePhotoType;
        }
        else if (!getState().claimSubmit.isInEdit) {
            var add = [];
            for (let i = 0; i < selectedDamagePhotoType.length; i++) {
                if (!prev.find(x => x.description == selectedDamagePhotoType[i].description)) {
                    add = add.concat(selectedDamagePhotoType[i]);
                }
            }
            next = prev.concat(add);
        }
        else if (getState().claimSubmit.isInEdit) {

            next = selectedDamagePhotoType;
        }
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                selectedDamagePhotoTypes: next,
            }
        });
    }
}

export const clearSelectedDamages = () => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                damageListCar: {
                    damageFront: false,
                    damageFrontLeft: false,
                    damageFrontRight: false,
                    damageBackLeft: false,
                    damageBackRight: false,
                    damageBack: false,
                    damageExtras: false,
                },
                hasDamageSelected: false,
            }
        });
    }
}

export const setSelectedAllTrue = () => {
    return async (dispatch, getState) => {
        var photoList = getState().claimSubmit.claimDamagePhotoTypes
        for (var i = 0; i < photoList.length; i++) {
            photoList[i].isSelected = true
        }
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                claimDamagePhotoTypes: photoList,
            },
        });
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                damageListCar: {
                    damageFront: true,
                    damageFrontLeft: true,
                    damageFrontRight: true,
                    damageBackLeft: true,
                    damageBackRight: true,
                    damageBack: true,
                    damageExtras: true,
                },
                hasDamageSelected: true,
            }
        });
    }
}

export const setSelectedAllFalse = () => {
    return async (dispatch, getState) => {
        var photoList = getState().claimSubmit.claimDamagePhotoTypes
        for (var i = 0; i < photoList.length; i++) {
            photoList[i].isSelected = false
        }
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                damageListCar: {
                    damageFront: false,
                    damageFrontLeft: false,
                    damageFrontRight: false,
                    damageBackLeft: false,
                    damageBackRight: false,
                    damageBack: false,
                    damageExtras: false,
                },
                hasDamageSelected: false,
                claimDamagePhotoTypes: photoList,
            }
        });
    }
}

export const setDamagePosition = (Position) => {
    return async (dispatch, getState) => {
        if (getState().claimSubmit.isCar) {
            var foundFront = Position.find(x => x.description == "Front") || Position.find(x => x.description == "Front window") || Position.find(x => x.description == "Bonnet");
            var foundFrontLeft = Position.find(x => x.description == "Front left") || Position.find(x => x.description == "Front left window") || Position.find(x => x.description == "Front left tyre") || Position.find(x => x.description == "Front left door");
            var foundFrontRight = Position.find(x => x.description == "Front right") || Position.find(x => x.description == "Front right window") || Position.find(x => x.description == "Front right tyre") || Position.find(x => x.description == "Front right door");
            var foundBackLeft = Position.find(x => x.description == "Back left") || Position.find(x => x.description == "Back left window") || Position.find(x => x.description == "Back left tyre") || Position.find(x => x.description == "Back left door");
            var foundBackRight = Position.find(x => x.description == "Back right") || Position.find(x => x.description == "Back right window") || Position.find(x => x.description == "Back right tyre") || Position.find(x => x.description == "Back right door");
            var foundBack = Position.find(x => x.description == "Back") || Position.find(x => x.description == "Back window") || Position.find(x => x.description == "Boot");
        } else {
            var foundFront = Position.find(x => getState().claimSubmit.mbFront.indexOf(x.description) >= 0);
            var foundFrontLeft = Position.find(x => getState().claimSubmit.mbFrontLeft.indexOf(x.description) >= 0);
            var foundFrontRight = Position.find(x => getState().claimSubmit.mbFrontRight.indexOf(x.description) >= 0);
            var foundBackLeft = Position.find(x => getState().claimSubmit.mbBackLeft.indexOf(x.description) >= 0);
            var foundBackRight = Position.find(x => getState().claimSubmit.mbBackRight.indexOf(x.description) >= 0);
            var foundBack = Position.find(x => getState().claimSubmit.mbBack.indexOf(x.description) >= 0);
        }

        if (foundFront) {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: true,
                        damageFrontLeft: getState().claimSubmit.damageListCar.damageFrontLeft,
                        damageFrontRight: getState().claimSubmit.damageListCar.damageFrontRight,
                        damageBackLeft: getState().claimSubmit.damageListCar.damageBackLeft,
                        damageBackRight: getState().claimSubmit.damageListCar.damageBackRight,
                        damageBack: getState().claimSubmit.damageListCar.damageBack
                    },
                }
            });
        } else {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: false,
                        damageFrontLeft: getState().claimSubmit.damageListCar.damageFrontLeft,
                        damageFrontRight: getState().claimSubmit.damageListCar.damageFrontRight,
                        damageBackLeft: getState().claimSubmit.damageListCar.damageBackLeft,
                        damageBackRight: getState().claimSubmit.damageListCar.damageBackRight,
                        damageBack: getState().claimSubmit.damageListCar.damageBack
                    },
                }
            });
        }

        if (foundFrontLeft) {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: getState().claimSubmit.damageListCar.damageFront,
                        damageFrontLeft: true,
                        damageFrontRight: getState().claimSubmit.damageListCar.damageFrontRight,
                        damageBackLeft: getState().claimSubmit.damageListCar.damageBackLeft,
                        damageBackRight: getState().claimSubmit.damageListCar.damageBackRight,
                        damageBack: getState().claimSubmit.damageListCar.damageBack
                    },
                }
            });
        } else {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: getState().claimSubmit.damageListCar.damageFront,
                        damageFrontLeft: false,
                        damageFrontRight: getState().claimSubmit.damageListCar.damageFrontRight,
                        damageBackLeft: getState().claimSubmit.damageListCar.damageBackLeft,
                        damageBackRight: getState().claimSubmit.damageListCar.damageBackRight,
                        damageBack: getState().claimSubmit.damageListCar.damageBack
                    },
                }
            });
        }

        if (foundFrontRight) {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: getState().claimSubmit.damageListCar.damageFront,
                        damageFrontLeft: getState().claimSubmit.damageListCar.damageFrontLeft,
                        damageFrontRight: true,
                        damageBackLeft: getState().claimSubmit.damageListCar.damageBackLeft,
                        damageBackRight: getState().claimSubmit.damageListCar.damageBackRight,
                        damageBack: getState().claimSubmit.damageListCar.damageBack
                    },
                }
            });
        } else {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: getState().claimSubmit.damageListCar.damageFront,
                        damageFrontLeft: getState().claimSubmit.damageListCar.damageFrontLeft,
                        damageFrontRight: false,
                        damageBackLeft: getState().claimSubmit.damageListCar.damageBackLeft,
                        damageBackRight: getState().claimSubmit.damageListCar.damageBackRight,
                        damageBack: getState().claimSubmit.damageListCar.damageBack
                    },
                }
            });
        }

        if (foundBackLeft) {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: getState().claimSubmit.damageListCar.damageFront,
                        damageFrontLeft: getState().claimSubmit.damageListCar.damageFrontLeft,
                        damageFrontRight: getState().claimSubmit.damageListCar.damageFrontRight,
                        damageBackLeft: true,
                        damageBackRight: getState().claimSubmit.damageListCar.damageBackRight,
                        damageBack: getState().claimSubmit.damageListCar.damageBack
                    },
                }
            });
        } else {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: getState().claimSubmit.damageListCar.damageFront,
                        damageFrontLeft: getState().claimSubmit.damageListCar.damageFrontLeft,
                        damageFrontRight: getState().claimSubmit.damageListCar.damageFrontRight,
                        damageBackLeft: false,
                        damageBackRight: getState().claimSubmit.damageListCar.damageBackRight,
                        damageBack: getState().claimSubmit.damageListCar.damageBack
                    },
                }
            });
        }

        if (foundBackRight) {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: getState().claimSubmit.damageListCar.damageFront,
                        damageFrontLeft: getState().claimSubmit.damageListCar.damageFrontLeft,
                        damageFrontRight: getState().claimSubmit.damageListCar.damageFrontRight,
                        damageBackLeft: getState().claimSubmit.damageListCar.damageBackLeft,
                        damageBackRight: true,
                        damageBack: getState().claimSubmit.damageListCar.damageBack
                    },
                }
            });
        } else {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: getState().claimSubmit.damageListCar.damageFront,
                        damageFrontLeft: getState().claimSubmit.damageListCar.damageFrontLeft,
                        damageFrontRight: getState().claimSubmit.damageListCar.damageFrontRight,
                        damageBackLeft: getState().claimSubmit.damageListCar.damageBackLeft,
                        damageBackRight: false,
                        damageBack: getState().claimSubmit.damageListCar.damageBack
                    },
                }
            });
        }

        if (foundBack) {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: getState().claimSubmit.damageListCar.damageFront,
                        damageFrontLeft: getState().claimSubmit.damageListCar.damageFrontLeft,
                        damageFrontRight: getState().claimSubmit.damageListCar.damageFrontRight,
                        damageBackLeft: getState().claimSubmit.damageListCar.damageBackLeft,
                        damageBackRight: getState().claimSubmit.damageListCar.damageBackRight,
                        damageBack: true
                    },
                }
            });
        } else {
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    damageListCar: {
                        damageFront: getState().claimSubmit.damageListCar.damageFront,
                        damageFrontLeft: getState().claimSubmit.damageListCar.damageFrontLeft,
                        damageFrontRight: getState().claimSubmit.damageListCar.damageFrontRight,
                        damageBackLeft: getState().claimSubmit.damageListCar.damageBackLeft,
                        damageBackRight: getState().claimSubmit.damageListCar.damageBackRight,
                        damageBack: false
                    },
                }
            });
        }
    }
}

export const setClaimType = (typeClaim) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                claimType: typeClaim
            }
        });
    }
}

export const getVehicleTypes = () => {
    return async (dispatch) => {
        await postToController(dispatch, 'GetVehicleTypes', null).then(async (response) => {
            if (response) {
                dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        claimVehicleTypes: response
                    }
                });
            }
        })
    }
}

export const getAllRiskStolenLocations = (vehicletypeid) => {
    return async (dispatch) => {
        await postToController(dispatch, 'GetAllRiskStolenLocations', JSON.stringify({ Parameter: vehicletypeid })).then(async (response) => {
            if (response) {
                dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        stolenLocations: response
                    }
                });
            }
        })
    }
}

export const getVehicleForcedEntryTypes = () => {
    return async (dispatch) => {
        await postToController(dispatch, 'GetVehicleForcedEntryTypes', null).then(async (response) => {
            if (response) {
                dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        forcedEntryType: response
                    }
                });
            }
        })
    }
}

export const submitGeneralClaim = () => {
    return async (dispatch, getState) => {
        logEvent('SSP_submit_claim_callback', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        await postToController(dispatch, 'SubmitGeneralClaim', JSON.stringify({
            policyId: getState().profile.policyId,
            fullName: getState().profile.name + " " + getState().profile.surname,
            contactNumber: getState().profile.cellphoneNumber !== "" ? getState().profile.cellphoneNumber : getState().profile.alternateNumber,
            productName: getState().claimSubmit.selectedRiskItem.productName,
            productDescription: getState().claimSubmit.selectedRiskItem.riskItems[0].description,
            policyNumber: getState().profile.personalPolicies[0].policyNumber,
            typeOfClaim: getState().claimSubmit.selectedRiskItem.productName,
            incidentDate: getState().claimSubmit.incidentDate,
            incidentTime: getState().claimSubmit.incidentTime,
            incidentDescription: getState().claimSubmit.whatDescription
        })).then(async (response) => {
            if (response !== null && !response.documentSent) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            }
        }).catch((err) => {
            logErrorToDatabase("Error post SubmitGeneralClaim, Error: " + err);
            dispatch(navigateTo(DASHBOARD));

            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
    }
}

export const setFollowUpSteps = (journey) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: journey
        });

        if (getState().claimSubmit.followUp && (getState().claimSubmit.followUpType === "multiple-collision" || getState().claimSubmit.followUpType == "pedestrian" || getState().claimSubmit.followUpType == "pothole")) {
            dispatch(showModalDrivabeSuccessSubmittedFollowUp());
        }
    }
}

export const getRoadSurfaceTypes = () => {
    return async (dispatch, getState) => {

        await postToController(dispatch, 'GetRoadSurfaceTypes',
            JSON.stringify({}))
            .then(async response => {
                if (response) {
                    dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            roadSurfaceTypes: response,
                        }
                    });
                }
            })
            .catch(err => logErrorToDatabase("Error logging GetRoadSurfaceTypes:" + err))
    }
}

export const getRoadConditions = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetRoadConditions',
            JSON.stringify({}))
            .then(async response => {
                if (response) {
                    dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            roadConditions: response,
                        }
                    });
                }
            })
            .catch(err => logErrorToDatabase("Error logging GetRoadConditions:" + err))
    }
}

export const getDamageCausesByProductIncidentTypeId = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetDamageCausesByProductIncidentTypeId',
            JSON.stringify({
                IncidentTypeId: getState().claimSubmit.incidentEventType.id,
                ProductId: getState().claimSubmit.selectedRiskItem.productId,
            }))
            .then(async response => {
                if (response) {
                    dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            damageCauses: response,
                        }
                    });
                }
            })
            .catch(err => logErrorToDatabase("Error logging GetDamageCausesByProductIncidentTypeId:" + err))
    }
}

export const getInsuranceCompaniesByCountryId = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetInsuranceCompaniesByCountryId',
            JSON.stringify({
                Parameter: getState().profile.countryId
            }))
            .then(async response => {
                if (response) {
                    dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            insuranceCompanies: response,
                        }
                    });
                }
                dispatch({
                    type: MODAL_HIDE,
                    modalProps: {
                        type: MODAL_TYPE_SUCCESS,
                        visible: false,
                    }
                });
            })
            .catch(err => logErrorToDatabase("Error logging GetInsuranceCompaniesByCountryId:" + err))
    }
}

export const checkDateTime = (dateTime: string) => {
    return async (dispatch) => {
        var returnValue = false;
        try {
            await postToController(dispatch, 'IsDateTimeValid',
                JSON.stringify({
                    Parameter: dateTime,
                })).then(async (response) => {
                    if (response !== null) {
                        returnValue = response;
                    }
                })
        } catch (err) {
            logErrorToDatabase("Error in checkDateTime, Error: " + err);
        }
        return returnValue;
    }
}

export const getDateString = (dateVar: string, timeVar: string) => {
    return dateVar.substring(6) + "-" + dateVar.substring(3, 5) + "-" + dateVar.substring(0, 2) + 'T' + (timeVar.length != 5 ? '0' : '') + timeVar;
}

export const setReducer = (type: string, name: string, value: any) => {
    return async (dispatch) => {
        await dispatch({
            type: type, payload: {
                [name]: value
            }
        });
    }
}

export const sendAddressChangeCallback = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'CreateExternalLeadRequest', JSON.stringify({
            FirstName: getState().profile.name,
            ContactNumber: getState().profile.cellphoneNumber,
            MobileNumber: getState().profile.cellphoneNumber,
            Kpcid: '10000409',
            Status: 'ACTIVE',
            Comments: "Address change requested",
            CountryId: getState().profile.countryId,
        })).then((response) => {
            if (response === true) {
                dispatch(showClaimsAddressChange());
            } else if (response !== true) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                })
            }
        }).catch((err) => {
            logErrorToDatabase("Error post createClaimsCallbackRequest, Error: " + err);
        })
    }
}
//#endregion

//#region glassClaims
export const setGlassDrillDown = (drillDownEnabled: boolean, location: string) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                glassDrillDown: drillDownEnabled,
                selectedGlassDrilldown: location,
            }
        });
    }
}

export const setGlassTooltip = (damageDescription: boolean) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                lastSelectedDamage: damageDescription,
            }
        });
    }
}

export const startGlassClaim = () => {
    return async (dispatch) => {
        await dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_CONFIRM_INCIDENT_AND_RISK
            }
        });
    }
}

export const initiateGlassSteps = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_STEPS_GLASS, payload: {
            }
        });
    }
}

export const initiateWarrantyClaimSteps = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_STEPS_CLAIMS_WARRANTY, payload: {
            }
        });
    }
}

export const submitGlassClaim = () => {
    return async (dispatch, getState) => {
        var functionResponse = false;
        await dispatch({ type: LOADING_SCREEN_SHOW });
        logEvent('SSP_submit_glass_claim', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        try {
            await postToController(dispatch, 'SubmitGlassClaim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentType: getState().claimSubmit.incidentEventType.id,
                    IncidentEventType: getState().claimSubmit.incidentType.id,
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.incidentTime,
                    IncidentDescription: getState().claimSubmit.whatDescription,
                    HasItBeenRepairedOrReplaced: getState().claimSubmit.hasBeenRepaired,
                    IsRepaired: getState().claimSubmit.isRepaired,
                    CanItBeRepaired: getState().claimSubmit.glassDamage,
                    HasSmashAndGrab: getState().claimSubmit.hasSmashAndGrab,
                    GlassFitmentContactName: getState().claimSubmit.contactPersonFullName,
                    GlassFitmentContactNumber: getState().claimSubmit.contactPersonNumber,
                    FitmentLocationLatitude: getState().claimSubmit.addressLat,
                    FitmentLocationLongitude: getState().claimSubmit.addressLon,
                    FitmentLocationAddressLine1: getState().claimSubmit.addressDetail.formatted,
                    FitmentLocationAddressLine2: "",
                    FitmentLocationCity:getState().claimSubmit.addressDetail.city,
                    FitmentLocationSuburb:getState().claimSubmit.addressDetail.suburb,
                    FitmentLocationPostalCode:getState().claimSubmit.addressDetail.postalCode,
                    FitmentLocationProvince:getState().claimSubmit.addressDetail.province,
                    AddressLine1: getState().claimSubmit.address,
                    DamageReport: {
                        FrontWindow: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Windshield')?.isSelected,
                        BackWindow: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Back window')?.isSelected,
                        FrontLeftVent: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Front left vent')?.isSelected,
                        FrontLeftWindow: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Front left window')?.isSelected,
                        BackLeftWindow: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Back left window')?.isSelected,
                        BackLeftQuarter: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Back left quarter')?.isSelected,
                        BackLeftVent: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Back left vent')?.isSelected,
                        FrontRightVent: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Front right vent')?.isSelected,
                        FrontRightWindow: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Front right window')?.isSelected,
                        BackRightWindow: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Back right window')?.isSelected,
                        BackRightQuarter: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Back right quarter')?.isSelected,
                        BackRightVent: getState().claimSubmit.claimDamagePhotoTypes.find(x => x.description === 'Back right vent')?.isSelected
                    }
                })).then(async (response) => {
                    if (response == null || response === "Failure") {
                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                        await dispatch({ type: LOADING_SCREEN_HIDE });
                        dispatch(navigateTo(DASHBOARD))
                    }
                    else {
                        await dispatch({
                            type: SET_CLAIM_DATA, payload: {
                                claimNumber: response.claimNumber,
                                claimStatus: response.status,
                                claimExcess: response.excess,
                                replacementExcessDescription: response.replacementExcessDescription,
                                repairExcessDescription: response.repairExcessDescription,
                            }
                        });
                        await dispatch(getCustomerClaims());
                        let claim = getState().profile.personalClaims.filter(x => x.claimNumber === response.claimNumber
                        )
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                selectedPersonalClaim: claim[0],
                            }
                        });
                        functionResponse = true;
                        await dispatch(handleNextStep())
                    }
                })
        } catch (err) {
            logErrorToDatabase("Error in submitGlassClaim, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}
//#endregion

//#region cellphoneClaims
export const checkCellphoneDuplicateClaim = (causeofDamageId: number, claimDate: string, claimTime: string, incidentTypeId: number, policyRiskItem: string) => {
    return async (dispatch, getState) => {
        var functionResponse = false;
        var customerId = getState().profile.customerId;

        await dispatch({ type: LOADING_SCREEN_SHOW });
        try {
            await postToController(dispatch, 'DuplicateClaimCheck', JSON.stringify({
                CauseOfDamage: causeofDamageId,
                CustomerId: customerId,
                Date: claimDate,
                Time: claimTime,
                IncidentType: incidentTypeId,
                IsBlingClaim: true,
                IsGlassClaim: false,
                IsRecovered: false,
                PolicyRiskItemId: policyRiskItem
            })).then(async (response) => {
                if (response.isDuplicate) {
                    await dispatch(getCustomerClaims());
                    let claim = getState().profile.personalClaims.filter(function (item) {
                        return item.claimNumber === response.claimsResponse.claimNumber
                    })
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            selectedPersonalClaim: claim[0],
                        }
                    });
                }
                if (response == null || response === "Failure") {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    });
                    await dispatch({ type: LOADING_SCREEN_HIDE });
                    dispatch(navigateTo(DASHBOARD))
                }
                else {
                    functionResponse = response.isDuplicate;
                }
            })
        } catch (err) {
            logErrorToDatabase("Error in DuplicateClaimCheck, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const initiateCellphoneSteps = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_STEPS_CELLPHONE, payload: {
            }
        });
    }
}

export const initiateCellphoneOtherSteps = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_STEPS_CELLPHONE_OTHER, payload: {
            }
        });
    }
}

export const submitBlingClaim = () => {
    return async (dispatch, getState) => {
        try {
            var request: MobileBlingClaimRequest = {
                policyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                incidentTypeId: getState().claimSubmit.incidentEventType.id,
                incidentDate: getState().claimSubmit.incidentDate,
                incidentTime: getState().claimSubmit.incidentTime,
                incidentDescription: getState().claimSubmit.whatDescription,
                hasItBeenRepairedOrReplaced: getState().claimSubmit.hasBeenRepaired,
                isRepaired: getState().claimSubmit.isRepaired,
                newDevice: getState().claimSubmit.newDeviceName,
                deliveryLocationLongitude: getState().claimSubmit.addressLon,
                deliveryLocationLatitude: getState().claimSubmit.addressLat,
                contactPersonFullName: getState().claimSubmit.contactPersonFullName,
                contactPersonNumber: getState().claimSubmit.contactPersonNumber,
                typeOfCar: getState().claimSubmit.selectedTypeOfCarId,
                isVisibleSignsOfEntryIntoCar: getState().claimSubmit.isVisibleSignsOfEntryIntoCar,
                howWasEntryGained: getState().claimSubmit.selectedEntryGainedId,
                whereWasTheItemInTheCar: getState().claimSubmit.selectedWhereInTheCarId,
                reportedToPolice: getState().claimSubmit.policeReported,
                policeStationName: getState().claimSubmit.policeReportStation,
                policeCaseNumber: getState().claimSubmit.policeReportNumber,
                wasBlacklisted: getState().claimSubmit.blackListed,
                blacklistReferenceNumber: getState().claimSubmit.blackListNumber,
                isResponsiblePersonMemberOfHousehold: getState().claimSubmit.isResponsiblePersonMemberOfHousehold,
                responsiblePersonFullName: getState().claimSubmit.responsiblePersonFullName,
                addressLine1: getState().claimSubmit.address,
                deliveryLocationAddressLine1: getState().claimSubmit.address,
                deliveryLocationAddressLine2: "",
                deliveryLocationCity:getState().claimSubmit.addressDetail.city,
                deliveryLocationSuburb:getState().claimSubmit.addressDetail.suburb,
                deliveryLocationPostalCode:getState().claimSubmit.addressDetail.postalCode,
                deliveryLocationProvince:getState().claimSubmit.addressDetail.province,
                responsiblePersonContactNumber: getState().claimSubmit.responsiblePersonContactNumber,
            }

            await dispatch({ type: LOADING_SCREEN_SHOW });
            logEvent('SSP_submit_cellphone_claim', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
            await postToController(dispatch, 'SubmitBlingClaim', JSON.stringify(request)).then(async (response) => {
                if (!response || response === "Failure" || response === "") {
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    });
                    await dispatch(navigateTo(DASHBOARD))
                } else {
                    await dispatch(handleNextStep())
                    var customerId = getState().profile.customerId;
                    var policyId = getState().profile.policyId;

                    await dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            claimNumber: response.result.claimNumber,
                            claimExcess: response.result.excess
                        }
                    });
                    await dispatch(getCustomerClaims());
                    let claim = getState().profile.personalClaims.filter(function (item) {
                        return item.claimNumber === response.result.claimNumber
                    });

                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            selectedPersonalClaim: claim[0],
                        }
                    });
                }
            }).catch(err => {
                logErrorToDatabase("Error submiting cellphone claim: " + err)
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
            }).finally(() => {
                dispatch({ type: LOADING_SCREEN_HIDE });
            })
        } catch (e) {
            await dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
            await dispatch(navigateTo(DASHBOARD))
        }
    }
}

export const submitBlingFNOL = () => {
    return async (dispatch, getState) => {
        var customerId = getState().profile.customerId;
        var functionResponse = false;
        await dispatch({ type: LOADING_SCREEN_SHOW });
        logEvent('SSP_submit_cellphone_fnol_claim', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        try {
            await postToController(dispatch, 'SubmitFNOLClaim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentEventType: 753, //FNOL Other
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.incidentTime,
                    IncidentDescription: getState().claimSubmit.whatDescription,
                    IsRecovered: false,
                    IsDrivable: false,
                    ContactPersonName: getState().claimSubmit.contactPersonFullName,
                    ContactPersonNumber: getState().claimSubmit.contactPersonNumber,
                    Lat: getState().claimSubmit.lat,
                    Lng: getState().claimSubmit.lon,
                    IncidentLocationAddressLine1: getState().claimSubmit.address,
                    IncidentLocationAddressLine2: "",
                    IncidentLocationCity:getState().claimSubmit.addressDetail.city,
                    IncidentLocationSuburb:getState().claimSubmit.addressDetail.suburb,
                    IncidentLocationPostalCode:getState().claimSubmit.addressDetail.postalCode,
                    IncidentLocationProvince:getState().claimSubmit.addressDetail.province,
                    AddressLine1: getState().claimSubmit.address,
                    CustomerId: customerId,
                    IncidentType: 52 //FNOL
                })).then(async (response) => {
                    if (response !== "Failure") {
                        await dispatch({
                            type: SET_CLAIM_DATA, payload: {
                                claimNumber: response.result.claimNumber,
                                isFnolClaim: true,
                            }
                        });
                        await dispatch(getCustomerClaims());
                        let claim = getState().profile.personalClaims.filter(function (item) {
                            return item.claimNumber === response.result.claimNumber
                        })
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                selectedPersonalClaim: claim[0],
                            }
                        });
                        functionResponse = true;
                    }
                    else {
                        await dispatch(navigateTo(DASHBOARD));

                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                    }
                })
        } catch (err) {
            logErrorToDatabase("Error in SubmitFNOLClaim, Error: " + err);
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
            await dispatch(navigateTo(DASHBOARD));
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}
//#endregion

//#region FNOL
export const setFnolReducerPayload = (payload) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_CLAIM_DATA, payload: payload
        });
    }
}

export const resetFNOL = () => {
    return async (dispatch) => {
        await dispatch({ type: RESET_CLAIM_DATA, payload: {} });
        await dispatch({ type: SET_STEPS_FNOL, payload: {} });
    }
}

export const showPhotoError = () => {
    return async (dispatch) => {
        await dispatch({
            type: MODAL_SHOW,
            modalProps: {
                type: MODAL_TYPE_ERROR,
                header: ERROR_HEADER,
                body: ERROR_INSPECTION_PHOTOS,
            }
        });
    }
}

export const showFnolTakePhoto = (description: string) => {
    return async (dispatch, getState) => {
        var photoList = getState().claimSubmit.claimDamagePhotoTypes
        for (var i = 0; i < photoList.length; i++) {
            if (photoList[i].description.toLowerCase() === description.toLowerCase()) {
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        selectedDamagePhotoTypes: photoList[i],
                    },
                });
                break;
            }
        }
    }
}

export const saveFnolPhoto = (description: string, photo: string) => {
    return async (dispatch, getState) => {
        var photoList = getState().claimSubmit.claimDamagePhotoTypes
        for (var i = 0; i < photoList.length; i++) {
            if (photoList[i].description.toLowerCase() === description.toLowerCase()) {
                photoList[i].photoData = photo;
                break;
            }
        }
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                claimDamagePhotoTypes: photoList,
            },
        });
    }
}

export const saveDamageSelected = (description: string) => {
    return async (dispatch, getState) => {
        var photoList = getState().claimSubmit.claimDamagePhotoTypes
        var selectedDamageDescription = "";
        for (var i = 0; i < photoList.length; i++) {
            if (photoList[i].description.toLowerCase() === description.toLowerCase()) {
                photoList[i].isSelected = !photoList[i].isSelected;
                selectedDamageDescription = photoList[i].description;
                break;
            }
        }
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                claimDamagePhotoTypes: photoList,
                lastSelectedDamage: selectedDamageDescription,
            },
        });
        var frontDamaged = false
        var frontLeftDamaged = false
        var frontRightDamaged = false
        var backDamaged = false
        var backRightDamaged = false
        var backLeftDamaged = false
        var extrasDamaged = false
        var hasDamage = false
        for (var i = 0; i < photoList.length; i++) {
            if (photoList[i].location.toLowerCase() === "front") {
                if (photoList[i].isSelected) {
                    frontDamaged = true
                }
            } else if (photoList[i].location.toLowerCase() === "frontleft") {
                if (photoList[i].isSelected) {
                    frontLeftDamaged = true
                }
            } else if (photoList[i].location.toLowerCase() === "frontright") {
                if (photoList[i].isSelected) {
                    frontRightDamaged = true
                }
            } else if (photoList[i].location.toLowerCase() === "back") {
                if (photoList[i].isSelected) {
                    backDamaged = true
                }
            } else if (photoList[i].location.toLowerCase() === "backleft") {
                if (photoList[i].isSelected) {
                    backLeftDamaged = true
                }
            } else if (photoList[i].location.toLowerCase() === "backright") {
                if (photoList[i].isSelected) {
                    backRightDamaged = true
                }
            }
            else if (photoList[i].location.toLowerCase() === "special") {
                if (photoList[i].isSelected) {
                    extrasDamaged = true
                }
            }
        }
        if (frontDamaged || frontLeftDamaged || frontRightDamaged || backDamaged || backLeftDamaged || backRightDamaged || extrasDamaged) {
            hasDamage = true
        }
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                damageListCar: {
                    damageFront: frontDamaged,
                    damageFrontLeft: frontLeftDamaged,
                    damageFrontRight: frontRightDamaged,
                    damageBackLeft: backLeftDamaged,
                    damageBackRight: backRightDamaged,
                    damageBack: backDamaged,
                    damageExtras: extrasDamaged,
                },
                hasDamageSelected: hasDamage,
            }
        });
    }
}

export const submitFNOL = () => {
    return async (dispatch, getState) => {
        var customerId = getState().profile.customerId;
        var functionResponse = false;
        logEvent('SSP_submit_fnol', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);

        await dispatch({ type: LOADING_SCREEN_SHOW });
        try {
            await postToController(dispatch, 'SubmitFNOLClaim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentEventType: getState().claimSubmit.incidentType.id,
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.incidentTime,
                    IncidentDescription: getState().claimSubmit.whatDescription,
                    IsRecovered: true,
                    IsDrivable: getState().claimSubmit.isDriveavle,
                    ContactPersonName: getState().claimSubmit.contactName,
                    ContactPersonNumber: getState().claimSubmit.contactNumber,
                    Lat: getState().claimSubmit.lat,
                    Lng: getState().claimSubmit.lon,
                    IncidentLocationAddressLine1: getState().claimSubmit.address,
                    IncidentLocationAddressLine2: "",
                    IncidentLocationCity:getState().claimSubmit.addressDetail.city,
                    IncidentLocationSuburb:getState().claimSubmit.addressDetail.suburb,
                    IncidentLocationPostalCode:getState().claimSubmit.addressDetail.postalCode,
                    IncidentLocationProvince:getState().claimSubmit.addressDetail.province,
                    AddressLine1: getState().claimSubmit.address,
                    CustomerId: customerId,
                    IncidentType: getState().claimSubmit.incidentType.id
                })).then(async (response) => {
                    if (response !== "Failure") {
                        await dispatch({
                            type: SET_CLAIM_DATA, payload: {
                                claimNumber: response.result.claimNumber,
                                isFnolClaim: true,
                            }
                        });
                        await dispatch(getCustomerClaims());
                        let claim = getState().profile.personalClaims.filter(function (item) {
                            return item.claimNumber === response.result.claimNumber
                        })
                        await dispatch({
                            type: SET_CUSTOMER_DATA, payload: {
                                selectedPersonalClaim: claim[0],
                            }
                        });
                        functionResponse = true;
                    }
                    else {
                        await dispatch(navigateTo(DASHBOARD));

                        dispatch({
                            type: MODAL_SHOW,
                            modalProps: {
                                type: MODAL_TYPE_ERROR,
                                header: ERROR_HEADER,
                                body: ERROR_SOMETHING_WENT_WRONG,
                            }
                        });
                    }
                })
        } catch (err) {
            logErrorToDatabase("Error in SubmitFNOLClaim, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const submitFNOLNotDriveable = () => {
    return async (dispatch, getState) => {
        var customerId = getState().profile.customerId;
        var functionResponse = false;

        await dispatch({ type: LOADING_SCREEN_SHOW });
        logEvent('SSP_submit_fnol_nondriveable', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        try {
            await postToController(dispatch, 'SubmitFNOLClaim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentEventType: getState().claimSubmit.incidentType.id,
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.incidentTime,
                    IncidentDescription: getState().claimSubmit.whatDescription,
                    IsRecovered: true,
                    IsDrivable: false,
                    ContactPersonName: getState().claimSubmit.contactName,
                    ContactPersonNumber: getState().claimSubmit.contactNumber,
                    Lat: getState().claimSubmit.lat,
                    Lng: getState().claimSubmit.lon,
                    IncidentLocationAddressLine1: getState().claimSubmit.address,
                    IncidentLocationAddressLine2: "",
                    IncidentLocationCity:getState().claimSubmit.addressDetail.city,
                    IncidentLocationSuburb:getState().claimSubmit.addressDetail.suburb,
                    IncidentLocationPostalCode:getState().claimSubmit.addressDetail.postalCode,
                    IncidentLocationProvince:getState().claimSubmit.addressDetail.province,
                    AddressLine1: getState().claimSubmit.address,
                    CustomerId: customerId,
                    IncidentType: getState().claimSubmit.incidentType.id
                })).then(async (response) => {
                    await dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            claimNumber: response.result.claimNumber,
                            claimId: response.result.claimId,
                            isFnolClaim: true,
                        }
                    });
                    await dispatch(getCustomerClaims());
                    let claim = getState().profile.personalClaims.filter(function (item) {
                        return item.claimNumber === response.result.claimNumber
                    })
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            selectedPersonalClaim: claim[0],
                        }
                    });
                    functionResponse = true;
                })
        } catch (err) {
            logErrorToDatabase("Error in SubmitFNOLClaim, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const submitFNOLAndPhoto = () => {
    return async (dispatch, getState) => {
        var customerId = getState().profile.customerId;
        var functionResponse = false;
        logEvent('SSP_submit_fnol_with_damage', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        await dispatch({ type: LOADING_SCREEN_SHOW });
        try {
            await postToController(dispatch, 'SubmitFNOLClaim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentEventType: getState().claimSubmit.incidentType.id,
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.incidentTime,
                    IncidentDescription: getState().claimSubmit.whatDescription,
                    IsRecovered: true,
                    IsDrivable: getState().claimSubmit.isDriveavle,
                    ContactPersonName: getState().claimSubmit.contactName,
                    ContactPersonNumber: getState().claimSubmit.contactNumber,
                    Lat: getState().claimSubmit.lat,
                    Lng: getState().claimSubmit.lon,
                    AddressLine1: getState().claimSubmit.address,
                    IncidentLocationAddressLine1: getState().claimSubmit.address,
                    IncidentLocationAddressLine2: "",
                    IncidentLocationCity:getState().claimSubmit.addressDetail.city,
                    IncidentLocationSuburb:getState().claimSubmit.addressDetail.suburb,
                    IncidentLocationPostalCode:getState().claimSubmit.addressDetail.postalCode,
                    IncidentLocationProvince:getState().claimSubmit.addressDetail.province,
                    CustomerId: customerId,
                    IncidentType: getState().claimSubmit.incidentType.id
                })).then(async (responseSubmit) => {
                    await postToController(dispatch, 'SubmitFNOLPhotoBatchUpload',
                        JSON.stringify({
                            ClaimId: responseSubmit.result.claimId,
                            RiskItem: getState().claimSubmit.selectedRiskItem.riskItems[0].riskItemId,
                        })).then(async (responsePhoto) => {
                            for (var i = 0; i < getState().claimSubmit.claimDamagePhotoTypes.length; i++) {
                                if (getState().claimSubmit.claimDamagePhotoTypes[i].isSelected) {
                                    var isLastPhoto = true;
                                    if (responseSubmit !== null) {
                                        for (var k = i + 1; k < getState().claimSubmit.claimDamagePhotoTypes.length; k++) {
                                            if (getState().claimSubmit.claimDamagePhotoTypes[k].isSelected) {
                                                isLastPhoto = false;
                                            }
                                        }
                                        if (getState().claimSubmit.claimDamagePhotoTypes[i].photoData !== "") {
                                            await postToController(dispatch, 'SubmitFNOLPhoto',
                                                JSON.stringify({
                                                    Data: getState().claimSubmit.claimDamagePhotoTypes[i].photoData,
                                                    RiskItemId: getState().claimSubmit.selectedRiskItem.riskItems[0].riskItemId,
                                                    PolicyId: getState().profile.selectedPersonalCover.id,
                                                    IsLast: isLastPhoto,
                                                    RiskItemType: 1,
                                                    PhotoType: getState().claimSubmit.claimDamagePhotoTypes[i].id,
                                                    PhotoBatchId: responsePhoto.photoBatchId
                                                }))
                                                .then(async response => {

                                                })
                                                .catch(err => logErrorToDatabase("Self inspection photo upload error:: " + err))
                                        }
                                    } else {
                                        await dispatch(navigateTo(DASHBOARD));
                                        dispatch({
                                            type: MODAL_SHOW,
                                            modalProps: {
                                                type: MODAL_TYPE_ERROR,
                                                header: ERROR_HEADER,
                                                body: ERROR_SOMETHING_WENT_WRONG,
                                            }
                                        });
                                        break;
                                    }
                                }
                            }
                            await dispatch({
                                type: SET_CLAIM_DATA, payload: {
                                    claimNumber: responseSubmit.result.claimNumber,
                                    isFnolClaim: true,
                                }
                            });
                            await dispatch(getCustomerClaims());
                            let claim = getState().profile.personalClaims.filter(function (item) {
                                return item.claimNumber === responseSubmit.result.claimNumber
                            })
                            await dispatch({
                                type: SET_CUSTOMER_DATA, payload: {
                                    selectedPersonalClaim: claim[0],
                                }
                            });
                            functionResponse = true;
                        })
                })
        }
        catch (err) {
            logErrorToDatabase("Error in SubmitFNOLClaim, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const submitDetailedFNOLMobile = () => {
    return async (dispatch, getState) => {
        var customerId = getState().profile.customerId;
        var functionResponse = false;
        logEvent('SSP_submit_fnol_with_damage_mobile', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        let claimMotorbikeDamage = {
            axle: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-axle".toLowerCase())[0]?.isSelected,
            back: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-back".toLowerCase())[0]?.isSelected,
            backCarrier: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backCarrier".toLowerCase())[0]?.isSelected,
            backLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backLeft".toLowerCase())[0]?.isSelected,
            backLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backLeftTyre".toLowerCase())[0]?.isSelected,
            backRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRight".toLowerCase())[0]?.isSelected,
            backRightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRightFairing".toLowerCase())[0]?.isSelected,
            backRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRightTyre".toLowerCase())[0]?.isSelected,
            chain: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-chain".toLowerCase())[0]?.isSelected,
            ClaimId: undefined,
            carrier: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-carrier".toLowerCase())[0]?.isSelected,
            clutchLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-clutchLever".toLowerCase())[0]?.isSelected,
            damageCauseId: null,
            damageCauseOther: null,
            damagedRepaired: null,
            damageRepairmentDetail: null,
            drivable: null,
            driveTrain: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-driveTrain".toLowerCase())[0]?.isSelected,
            engine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-engine".toLowerCase())[0]?.isSelected,
            exhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-exhaust".toLowerCase())[0]?.isSelected,
            frame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frame".toLowerCase())[0]?.isSelected,
            front: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-front".toLowerCase())[0]?.isSelected,
            frontBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontbrake".toLowerCase())[0]?.isSelected,
            frontFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontfairing".toLowerCase())[0]?.isSelected,
            frontLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeft".toLowerCase())[0]?.isSelected,
            frontLeftBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontleftbrake".toLowerCase())[0]?.isSelected,
            frontLeftFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftFairing".toLowerCase())[0]?.isSelected,
            frontLeftShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftShock".toLowerCase())[0]?.isSelected,
            frontLeftSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftSuspension".toLowerCase())[0]?.isSelected,
            frontLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftTyre".toLowerCase())[0]?.isSelected,
            frontMudguard: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontMudguard".toLowerCase())[0]?.isSelected,
            frontRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRight".toLowerCase())[0]?.isSelected,
            frontRightBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightfrontbrake".toLowerCase())[0]?.isSelected,
            frontRightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightFairing".toLowerCase())[0]?.isSelected,
            frontRightShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightShock".toLowerCase())[0]?.isSelected,
            frontRightSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightSuspension".toLowerCase())[0]?.isSelected,
            frontRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightTyre".toLowerCase())[0]?.isSelected,
            frontTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontTyre".toLowerCase())[0]?.isSelected,
            gasTank: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gasTank".toLowerCase())[0]?.isSelected,
            gearLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gearLever".toLowerCase())[0]?.isSelected,
            gearShifter: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gearShifter".toLowerCase())[0]?.isSelected,
            glassRepairable: null,
            handlebars: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-handlebars".toLowerCase())[0]?.isSelected,
            headlight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-headlight".toLowerCase())[0]?.isSelected,
            instruments: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-instruments".toLowerCase())[0]?.isSelected,
            leftFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftFairing".toLowerCase())[0]?.isSelected,
            leftFrontFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftFrontFootrest".toLowerCase())[0]?.isSelected,
            leftIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftIndicator".toLowerCase())[0]?.isSelected,
            leftMirror: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftMirror".toLowerCase())[0]?.isSelected,
            leftRearFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearFootrest".toLowerCase())[0]?.isSelected,
            leftRearIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearIndicator".toLowerCase())[0]?.isSelected,
            leftRearSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearSuspension".toLowerCase())[0]?.isSelected,
            leftShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftShock".toLowerCase())[0]?.isSelected,
            leftSideEngine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideEngine".toLowerCase())[0]?.isSelected,
            leftSideExhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideExhaust".toLowerCase())[0]?.isSelected,
            leftSideFrame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideFrame".toLowerCase())[0]?.isSelected,
            passengerSeat: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-passengerSeat".toLowerCase())[0]?.isSelected,
            rearBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearbrake".toLowerCase())[0]?.isSelected,
            rearBreakLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearBreakLever".toLowerCase())[0]?.isSelected,
            rearFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearFairing".toLowerCase())[0]?.isSelected,
            rearLeftBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftrearbrake".toLowerCase())[0]?.isSelected,
            rearMudguard: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearMudguard".toLowerCase())[0]?.isSelected,
            rearRightBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightrearbrake".toLowerCase())[0]?.isSelected,
            rearShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearShock".toLowerCase())[0]?.isSelected,
            rearTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearTyre".toLowerCase())[0]?.isSelected,
            rightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightFairing".toLowerCase())[0]?.isSelected,
            rightFrontFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightFrontFootrest".toLowerCase())[0]?.isSelected,
            rightIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightIndicator".toLowerCase())[0]?.isSelected,
            rightMirror: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightMirror".toLowerCase())[0]?.isSelected,
            rightRearFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearFootrest".toLowerCase())[0]?.isSelected,
            rightRearIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearIndicator".toLowerCase())[0]?.isSelected,
            rightRearSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearSuspension".toLowerCase())[0]?.isSelected,
            rightShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightShock".toLowerCase())[0]?.isSelected,
            rightSideEngine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideEngine".toLowerCase())[0]?.isSelected,
            rightSideExhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideExhaust".toLowerCase())[0]?.isSelected,
            rightSideFrame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideFrame".toLowerCase())[0]?.isSelected,
            seat: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-seat".toLowerCase())[0]?.isSelected,
            sendAuthToSupplier: null,
            shock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-shock".toLowerCase())[0]?.isSelected,
            sprocket: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-sprocket".toLowerCase())[0]?.isSelected,
            suspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-suspension".toLowerCase())[0]?.isSelected,
            tailLight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-tailLight".toLowerCase())[0]?.isSelected,
            windshield: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-windshield".toLowerCase())[0]?.isSelected,

        }
        let claimCarDamage = {
            AdditionalDamageDetail: "",
            AirbagPopped: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-AirbagPopped".toLowerCase())[0]?.isSelected,
            Back: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Back".toLowerCase())[0]?.isSelected,
            BackLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeft".toLowerCase())[0]?.isSelected,
            BackLeftDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeftDoor".toLowerCase())[0]?.isSelected,
            BackLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeftTyre".toLowerCase())[0]?.isSelected,
            BackRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRight".toLowerCase())[0]?.isSelected,
            BackRightDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRightDoor".toLowerCase())[0]?.isSelected,
            BackRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRightTyre".toLowerCase())[0]?.isSelected,
            Bonnet: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Bonnet".toLowerCase())[0]?.isSelected,
            Boot: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Boot".toLowerCase())[0]?.isSelected,
            ClaimGuiltyParty: getState().claimSubmit.claimGuiltyParty,
            DamageCauseId: 35,
            DamageCauseOther: "",
            DamagedRepaired: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-DamagedRepaired".toLowerCase())[0]?.isSelected,
            DamageRepairmentDetail: "",
            Front: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Front".toLowerCase())[0]?.isSelected,
            FrontLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeft".toLowerCase())[0]?.isSelected,
            FrontLeftDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeftDoor".toLowerCase())[0]?.isSelected,
            FrontLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeftTyre".toLowerCase())[0]?.isSelected,
            FrontRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRight".toLowerCase())[0]?.isSelected,
            FrontRightDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRightDoor".toLowerCase())[0]?.isSelected,
            FrontRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRightTyre".toLowerCase())[0]?.isSelected,
            FrontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Windscreen".toLowerCase())[0]?.isSelected,
            Interior: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Interior".toLowerCase())[0]?.isSelected,
            LeftBackWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backleftwindow".toLowerCase())[0]?.isSelected,
            LeftFrontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-frontleftwindow".toLowerCase())[0]?.isSelected,
            RearWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backwindow".toLowerCase())[0]?.isSelected,
            RightBackWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backrightwindow".toLowerCase())[0]?.isSelected,
            RightFrontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-frontrightwindow".toLowerCase())[0]?.isSelected,
            Rolled: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Rolled".toLowerCase())[0]?.isSelected,
            Roof: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Roof".toLowerCase())[0]?.isSelected,
            StandardPartsDescription: "",
            StandardPartsStolen: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-StandardPartsStolen".toLowerCase())[0]?.isSelected,
            Sunroof: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Sunroof".toLowerCase())[0]?.isSelected,
            UnderCarriage: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-undercarriagedamage".toLowerCase())[0]?.isSelected,
            VehicleLocks: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-locks".toLowerCase())[0]?.isSelected,
        }

        await dispatch({ type: LOADING_SCREEN_SHOW });
        try {
            await postToController(dispatch, 'SubmitDetailedFNOLClaim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentEventType: getState().claimSubmit.incidentType.id,
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.incidentTime,
                    IncidentDescription: getState().claimSubmit.whatDescription,
                    IsRecovered: true,
                    IsDrivable: getState().claimSubmit.isDriveavle,
                    ContactPersonName: getState().claimSubmit.contactName,
                    ContactPersonNumber: getState().claimSubmit.contactNumber,
                    Lat: getState().claimSubmit.lat,
                    Lng: getState().claimSubmit.lon,
                    IncidentLocationAddressLine1: getState().claimSubmit.address,
                    IncidentLocationAddressLine2: "",
                    IncidentLocationCity:getState().claimSubmit.addressDetail.city,
                    IncidentLocationSuburb:getState().claimSubmit.addressDetail.suburb,
                    IncidentLocationPostalCode:getState().claimSubmit.addressDetail.postalCode,
                    IncidentLocationProvince:getState().claimSubmit.addressDetail.province,
                    CustomerId: customerId,
                    IncidentType: getState().claimSubmit.incidentType.id,
                    AddUpdateClaimMessage: {
                        ClaimCarDamage: getState().claimSubmit.isCar ? claimCarDamage : null,
                        ClaimMotorbikeDamage: getState().claimSubmit.isCar ? null : claimMotorbikeDamage,
                        RiskItemId: getState().claimSubmit.selectedRiskItem.id
                    }
                })).then(async (responseSubmit) => {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: responseSubmit.claimId,
                            body: responseSubmit.riskItemId,
                        }
                    });
                    await postToController(dispatch, 'SubmitFNOLPhotoBatchUpload',
                        JSON.stringify({
                            ClaimId: responseSubmit.result.claimId,
                            RiskItem: getState().claimSubmit.selectedRiskItem.riskItems[0].riskItemId,
                        })).then(async (responsePhoto) => {
                            for (var i = 0; i < getState().claimSubmit.claimDamagePhotoTypes.length; i++) {
                                if (getState().claimSubmit.claimDamagePhotoTypes[i].isSelected) {
                                    var isLastPhoto = true;
                                    if (responseSubmit !== null) {
                                        for (var k = i + 1; k < getState().claimSubmit.claimDamagePhotoTypes.length; k++) {
                                            if (getState().claimSubmit.claimDamagePhotoTypes[k].isSelected) {
                                                isLastPhoto = false;
                                            }
                                        }
                                        if (getState().claimSubmit.claimDamagePhotoTypes[i].photoData !== "") {
                                            await postToController(dispatch, 'SubmitFNOLPhoto',
                                                JSON.stringify({
                                                    Data: getState().claimSubmit.claimDamagePhotoTypes[i].photoData,
                                                    RiskItemId: getState().claimSubmit.selectedRiskItem.riskItems[0].riskItemId,
                                                    PolicyId: getState().profile.selectedPersonalCover.id,
                                                    IsLast: isLastPhoto,
                                                    RiskItemType: 1,
                                                    PhotoType: getState().claimSubmit.claimDamagePhotoTypes[i].id,
                                                    PhotoBatchId: responsePhoto.photoBatchId
                                                }))
                                                .then(async response => {

                                                })
                                                .catch(err => logErrorToDatabase("Self inspection photo upload error:: " + err))
                                        }
                                    } else {
                                        await dispatch(navigateTo(DASHBOARD));
                                        dispatch({
                                            type: MODAL_SHOW,
                                            modalProps: {
                                                type: MODAL_TYPE_ERROR,
                                                header: ERROR_HEADER,
                                                body: ERROR_SOMETHING_WENT_WRONG,
                                            }
                                        });
                                        break;
                                    }
                                }
                            }
                            await dispatch({
                                type: SET_CLAIM_DATA, payload: {
                                    claimNumber: responseSubmit.result.claimNumber,
                                    isFnolClaim: true,
                                }
                            });
                            await dispatch(getCustomerClaims());
                            let claim = getState().profile.personalClaims.filter(function (item) {
                                return item.claimNumber === responseSubmit.result.claimNumber
                            })
                            await dispatch({
                                type: SET_CUSTOMER_DATA, payload: {
                                    selectedPersonalClaim: claim[0],
                                }
                            });
                            functionResponse = true;
                        })
                })
        }
        catch (err) {
            logErrorToDatabase("Error in SubmitFNOLClaim, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const submitDetailedFNOL = () => {
    return async (dispatch, getState) => {
        var customerId = getState().profile.customerId;
        var functionResponse = false;

        let claimMotorbikeDamage = {
            axle: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-axle".toLowerCase())[0]?.isSelected,
            back: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-back".toLowerCase())[0]?.isSelected,
            backCarrier: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backCarrier".toLowerCase())[0]?.isSelected,
            backLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backLeft".toLowerCase())[0]?.isSelected,
            backLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backLeftTyre".toLowerCase())[0]?.isSelected,
            backRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRight".toLowerCase())[0]?.isSelected,
            backRightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRightFairing".toLowerCase())[0]?.isSelected,
            backRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRightTyre".toLowerCase())[0]?.isSelected,
            chain: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-chain".toLowerCase())[0]?.isSelected,
            ClaimId: undefined,
            carrier: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-carrier".toLowerCase())[0]?.isSelected,
            clutchLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-clutchLever".toLowerCase())[0]?.isSelected,
            damageCauseId: null,
            damageCauseOther: null,
            damagedRepaired: null,
            damageRepairmentDetail: null,
            drivable: null,
            driveTrain: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-driveTrain".toLowerCase())[0]?.isSelected,
            engine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-engine".toLowerCase())[0]?.isSelected,
            exhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-exhaust".toLowerCase())[0]?.isSelected,
            frame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frame".toLowerCase())[0]?.isSelected,
            front: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-front".toLowerCase())[0]?.isSelected,
            frontBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontbrake".toLowerCase())[0]?.isSelected,
            frontFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontfairing".toLowerCase())[0]?.isSelected,
            frontLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeft".toLowerCase())[0]?.isSelected,
            frontLeftBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontleftbrake".toLowerCase())[0]?.isSelected,
            frontLeftFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftFairing".toLowerCase())[0]?.isSelected,
            frontLeftShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftShock".toLowerCase())[0]?.isSelected,
            frontLeftSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftSuspension".toLowerCase())[0]?.isSelected,
            frontLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftTyre".toLowerCase())[0]?.isSelected,
            frontMudguard: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontMudguard".toLowerCase())[0]?.isSelected,
            frontRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRight".toLowerCase())[0]?.isSelected,
            frontRightBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightfrontbrake".toLowerCase())[0]?.isSelected,
            frontRightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightFairing".toLowerCase())[0]?.isSelected,
            frontRightShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightShock".toLowerCase())[0]?.isSelected,
            frontRightSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightSuspension".toLowerCase())[0]?.isSelected,
            frontRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightTyre".toLowerCase())[0]?.isSelected,
            frontTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontTyre".toLowerCase())[0]?.isSelected,
            gasTank: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gasTank".toLowerCase())[0]?.isSelected,
            gearLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gearLever".toLowerCase())[0]?.isSelected,
            gearShifter: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gearShifter".toLowerCase())[0]?.isSelected,
            glassRepairable: null,
            handlebars: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-handlebars".toLowerCase())[0]?.isSelected,
            headlight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-headlight".toLowerCase())[0]?.isSelected,
            instruments: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-instruments".toLowerCase())[0]?.isSelected,
            leftFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftFairing".toLowerCase())[0]?.isSelected,
            leftFrontFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftFrontFootrest".toLowerCase())[0]?.isSelected,
            leftIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftIndicator".toLowerCase())[0]?.isSelected,
            leftMirror: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftMirror".toLowerCase())[0]?.isSelected,
            leftRearFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearFootrest".toLowerCase())[0]?.isSelected,
            leftRearIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearIndicator".toLowerCase())[0]?.isSelected,
            leftRearSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearSuspension".toLowerCase())[0]?.isSelected,
            leftShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftShock".toLowerCase())[0]?.isSelected,
            leftSideEngine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideEngine".toLowerCase())[0]?.isSelected,
            leftSideExhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideExhaust".toLowerCase())[0]?.isSelected,
            leftSideFrame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideFrame".toLowerCase())[0]?.isSelected,
            passengerSeat: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-passengerSeat".toLowerCase())[0]?.isSelected,
            rearBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearbrake".toLowerCase())[0]?.isSelected,
            rearBreakLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearBreakLever".toLowerCase())[0]?.isSelected,
            rearFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearFairing".toLowerCase())[0]?.isSelected,
            rearLeftBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftrearbrake".toLowerCase())[0]?.isSelected,
            rearMudguard: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearMudguard".toLowerCase())[0]?.isSelected,
            rearRightBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightrearbrake".toLowerCase())[0]?.isSelected,
            rearShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearShock".toLowerCase())[0]?.isSelected,
            rearTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearTyre".toLowerCase())[0]?.isSelected,
            rightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightFairing".toLowerCase())[0]?.isSelected,
            rightFrontFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightFrontFootrest".toLowerCase())[0]?.isSelected,
            rightIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightIndicator".toLowerCase())[0]?.isSelected,
            rightMirror: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightMirror".toLowerCase())[0]?.isSelected,
            rightRearFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearFootrest".toLowerCase())[0]?.isSelected,
            rightRearIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearIndicator".toLowerCase())[0]?.isSelected,
            rightRearSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearSuspension".toLowerCase())[0]?.isSelected,
            rightShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightShock".toLowerCase())[0]?.isSelected,
            rightSideEngine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideEngine".toLowerCase())[0]?.isSelected,
            rightSideExhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideExhaust".toLowerCase())[0]?.isSelected,
            rightSideFrame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideFrame".toLowerCase())[0]?.isSelected,
            seat: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-seat".toLowerCase())[0]?.isSelected,
            sendAuthToSupplier: null,
            shock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-shock".toLowerCase())[0]?.isSelected,
            sprocket: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-sprocket".toLowerCase())[0]?.isSelected,
            suspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-suspension".toLowerCase())[0]?.isSelected,
            tailLight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-tailLight".toLowerCase())[0]?.isSelected,
            windshield: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-windshield".toLowerCase())[0]?.isSelected,

        }
        let claimCarDamage = {
            AdditionalDamageDetail: "",
            AirbagPopped: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-AirbagPopped".toLowerCase())[0]?.isSelected,
            Back: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Back".toLowerCase())[0]?.isSelected,
            BackLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeft".toLowerCase())[0]?.isSelected,
            BackLeftDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeftDoor".toLowerCase())[0]?.isSelected,
            BackLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeftTyre".toLowerCase())[0]?.isSelected,
            BackRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRight".toLowerCase())[0]?.isSelected,
            BackRightDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRightDoor".toLowerCase())[0]?.isSelected,
            BackRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRightTyre".toLowerCase())[0]?.isSelected,
            Bonnet: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Bonnet".toLowerCase())[0]?.isSelected,
            Boot: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Boot".toLowerCase())[0]?.isSelected,
            ClaimGuiltyParty: getState().claimSubmit.claimGuiltyParty,
            DamageCauseId: 35,
            DamageCauseOther: "",
            DamagedRepaired: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-DamagedRepaired".toLowerCase())[0]?.isSelected,
            DamageRepairmentDetail: "",
            Front: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Front".toLowerCase())[0]?.isSelected,
            FrontLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeft".toLowerCase())[0]?.isSelected,
            FrontLeftDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeftDoor".toLowerCase())[0]?.isSelected,
            FrontLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeftTyre".toLowerCase())[0]?.isSelected,
            FrontRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRight".toLowerCase())[0]?.isSelected,
            FrontRightDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRightDoor".toLowerCase())[0]?.isSelected,
            FrontRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRightTyre".toLowerCase())[0]?.isSelected,
            FrontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Windscreen".toLowerCase())[0]?.isSelected,
            Interior: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Interior".toLowerCase())[0]?.isSelected,
            LeftBackWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backleftwindow".toLowerCase())[0]?.isSelected,
            LeftFrontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-frontleftwindow".toLowerCase())[0]?.isSelected,
            RearWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backwindow".toLowerCase())[0]?.isSelected,
            RightBackWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backrightwindow".toLowerCase())[0]?.isSelected,
            RightFrontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-frontrightwindow".toLowerCase())[0]?.isSelected,
            Rolled: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Rolled".toLowerCase())[0]?.isSelected,
            Roof: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Roof".toLowerCase())[0]?.isSelected,
            StandardPartsDescription: "",
            StandardPartsStolen: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-StandardPartsStolen".toLowerCase())[0]?.isSelected,
            Sunroof: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Sunroof".toLowerCase())[0]?.isSelected,
            UnderCarriage: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-undercarriagedamage".toLowerCase())[0]?.isSelected,
            VehicleLocks: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-locks".toLowerCase())[0]?.isSelected,
        }

        await dispatch({ type: LOADING_SCREEN_SHOW });
        try {
            await postToController(dispatch, 'SubmitDetailedFNOLClaim',
                JSON.stringify({
                    PolicyRiskItemId: getState().claimSubmit.selectedRiskItem.id,
                    IncidentEventType: getState().claimSubmit.incidentType.id,
                    IncidentDate: getState().claimSubmit.incidentDate,
                    IncidentTime: getState().claimSubmit.incidentTime,
                    IncidentDescription: getState().claimSubmit.whatDescription,
                    IsRecovered: true,
                    IsDrivable: getState().claimSubmit.isDriveavle,
                    ContactPersonName: getState().claimSubmit.contactName,
                    ContactPersonNumber: getState().claimSubmit.contactNumber,
                    Lat: getState().claimSubmit.lat,
                    Lng: getState().claimSubmit.lon,
                    IncidentLocationAddressLine1: getState().claimSubmit.address,
                    IncidentLocationAddressLine2: "",
                    IncidentLocationCity:getState().claimSubmit.addressDetail.city,
                    IncidentLocationSuburb:getState().claimSubmit.addressDetail.suburb,
                    IncidentLocationPostalCode:getState().claimSubmit.addressDetail.postalCode,
                    IncidentLocationProvince:getState().claimSubmit.addressDetail.province,
                    CustomerId: customerId,
                    IncidentType: getState().claimSubmit.incidentType.id,
                    AddUpdateClaimMessage: {
                        ClaimCarDamage: getState().claimSubmit.isCar ? claimCarDamage : null,
                        ClaimMotorbikeDamage: getState().claimSubmit.isCar ? null : claimMotorbikeDamage,
                        RiskItemId: getState().claimSubmit.selectedRiskItem.id
                    }
                })).then(async (responseSubmit) => {
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: "claimId: " + responseSubmit.claimId,
                            body: "riskItemId: " + responseSubmit.riskItemId,
                        }
                    });

                    await dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            claimNumber: responseSubmit.result.claimNumber,
                            isFnolClaim: true,
                        }
                    });
                    await dispatch(getCustomerClaims());
                    let claim = getState().profile.personalClaims.filter(function (item) {
                        return item.claimNumber === responseSubmit.result.claimNumber
                    })
                    await dispatch({
                        type: SET_CUSTOMER_DATA, payload: {
                            selectedPersonalClaim: claim[0],
                        }
                    });
                    functionResponse = true;

                })
        }
        catch (err) {
            logErrorToDatabase("Error in SubmitFNOLClaim, Error: " + err);
        }
        await dispatch({ type: LOADING_SCREEN_HIDE });
        return functionResponse
    }
}

export const initiateFNOLSteps = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_STEPS_FNOL, payload: {
                isFnolClaim: true,
            }
        });
    }
}

export const resetSelectedFNOLItems = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                selectedRiskItem: "",
                incidentType: "",
                fnolStep: 1,
                fnolSubStep: 1,
                selectedClaimStep: { maxSubSteps: 2, stepLabel: 1, step: 1, subStep: 1, maxMobileSubSteps: 2, title: 'Claim details', subTitle: 'We need a few details' },
            }
        });
    }
}
//#endregion

//#region driveableClaims
export const initiateDrivableSteps = () => {
    return async (dispatch) => {

        dispatch({
            type: SET_STEPS_DRIVABLE, payload: {
                isFnolClaim: false,
            }
        });
    }
}

export const submitDrivableClaim = (isRecordPurpose, isThirdPartyclaim) => {
    return async (dispatch, getState) => {
        dispatch(showLoadingScreen());
        logEvent('SSP_submit_driveable_claim', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        var isCar = getState().claimSubmit.isCar;
        var claimantObj: ClaimantDetail = {
            relationshipTypeId: 1,
            claimantActingReasonId: undefined,
            customerId: getState().profile.customerId,
            firstName: getState().profile.name,
            surname: getState().profile.surname,
            idNumber: getState().profile.idNumber,
            idTypeId: 1,
            homePhone: "",
            workPhone: "",
            cellPhone: getState().profile.cellphoneNumber,
            email: getState().profile.email,
        };
        var dateVar = getState().claimSubmit.incidentDate.substring(6) + "-" + getState().claimSubmit.incidentDate.substring(3, 5) + "-" + getState().claimSubmit.incidentDate.substring(0, 2) + 'T' + (getState().claimSubmit.incidentTime.length != 5 ? '0' : '') + getState().claimSubmit.incidentTime;
        var createIncidentObj: CreateIncident = {
            catastropheId: undefined,
            policyId: getState().profile.selectedPersonalPolicy.id,
            claimant: claimantObj,
            description: getState().claimSubmit.whatDescription,
            incidentDate: dateVar,
            isIncidentDateUnknown: false
        }
        var initiateObj: InitiateClaim = {
            riskItemId: getState().claimSubmit.selectedRiskItem.id,
            claimAttributes: [
                1,
                3
            ],
            coverId: getState().claimSubmit.selectedRiskItem.policyCoverId,
            lossDate: dateVar,
            claimRecordPurpose: isRecordPurpose,
            claimThirdPartyInsurer: isThirdPartyclaim,
            claimantDetail: claimantObj,
            incidentId: undefined,
            incidentTypeId: getState().claimSubmit.incidentEventType.id,
            productId: getState().claimSubmit.selectedRiskItem.productId,
            temporaryClaimId: undefined,
            thirdPartyClaimId: undefined
        }

        //Collision damage cause overrides
        let damageCauseId = getState().claimSubmit.damageCauseId !== undefined ? getState().claimSubmit.damageCauseId : undefined;
        switch (getState().claimSubmit.incidentEventType.id) {
            case CLAIM_INCIDENT_TYPE_ANIMAL: {
                damageCauseId = CLAIM_DAMAGE_CAUSE_ANIMAL;
                break;
            }
            case CLAIM_INCIDENT_TYPE_POTHOLE: {
                damageCauseId = CLAIM_DAMAGE_CAUSE_POTHOLE;
                break;
            }
            case CLAIM_INCIDENT_TYPE_PEDESTRIAN: {
                damageCauseId = CLAIM_DAMAGE_CAUSE_PEDESTRIAN;
                break;
            }
            case CLAIM_INCIDENT_TYPE_SINGLE_VEHICLE_STATIONARY: {
                damageCauseId = CLAIM_DAMAGE_CAUSE_SINGLE_VEHICLE_STATIONARY;
                break;
            }
            case CLAIM_INCIDENT_TYPE_MULTI_VEHICLE_STATIONARY: {
                damageCauseId = CLAIM_DAMAGE_CAUSE_MULTI_VEHICLE_STATIONARY;
                break;
            }
            case CLAIM_INCIDENT_TYPE_SINGLE_VEHICLE_DRIVEN: {
                damageCauseId = CLAIM_DAMAGE_CAUSE_SINGLE_VEHICLE_DRIVEN;
                break;
            }
            case CLAIM_INCIDENT_TYPE_TYRE_BURST: {
                damageCauseId = CLAIM_DAMAGE_CAUSE_TYRE_BURST;
                break;
            }
            case CLAIM_INCIDENT_TYPE_TRACK_INCIDENT_MOTOR:
            case CLAIM_INCIDENT_TYPE_TRACK_INCIDENT_MOTORBIKE: {
                damageCauseId = CLAIM_DAMAGE_CAUSE_TRACK_INCIDENT;
                break;
            }
        }

        let claimMotorbikeDamage: AddUpdateMotorBikeDamageOnClaim = {
            additionalDamageDetail: getState().claimSubmit.extraDescription,
            axle: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-axle".toLowerCase())[0]?.isSelected,
            back: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-back".toLowerCase())[0]?.isSelected,
            backCarrier: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backCarrier".toLowerCase())[0]?.isSelected,
            backLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backLeft".toLowerCase())[0]?.isSelected,
            backLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backLeftTyre".toLowerCase())[0]?.isSelected,
            backRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRight".toLowerCase())[0]?.isSelected,
            backRightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRightFairing".toLowerCase())[0]?.isSelected,
            backLeftFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backLeftFairing".toLowerCase())[0]?.isSelected,
            backRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRightTyre".toLowerCase())[0]?.isSelected,
            chain: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-chain".toLowerCase())[0]?.isSelected,
            claimId: undefined,
            carrier: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-carrier".toLowerCase())[0]?.isSelected,
            clutchLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-clutchLever".toLowerCase())[0]?.isSelected,
            damageCauseId: damageCauseId,
            damageCauseOther: undefined,
            damagedRepaired: undefined,
            damageRepairmentDetail: undefined,
            drivable: undefined,
            driveTrain: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-driveTrain".toLowerCase())[0]?.isSelected,
            engine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-engine".toLowerCase())[0]?.isSelected,
            exhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-exhaust".toLowerCase())[0]?.isSelected,
            frame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frame".toLowerCase())[0]?.isSelected,
            front: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-front".toLowerCase())[0]?.isSelected,
            frontBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontbrake".toLowerCase())[0]?.isSelected,
            frontFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontfairing".toLowerCase())[0]?.isSelected,
            frontLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeft".toLowerCase())[0]?.isSelected,
            frontLeftBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontleftbrake".toLowerCase())[0]?.isSelected,
            frontLeftFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftFairing".toLowerCase())[0]?.isSelected,
            frontLeftShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftShock".toLowerCase())[0]?.isSelected,
            frontLeftSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftSuspension".toLowerCase())[0]?.isSelected,
            frontLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftTyre".toLowerCase())[0]?.isSelected,
            frontMudguard: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontMudguard".toLowerCase())[0]?.isSelected,
            frontRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRight".toLowerCase())[0]?.isSelected,
            frontRightBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightfrontbrake".toLowerCase())[0]?.isSelected,
            frontRightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightFairing".toLowerCase())[0]?.isSelected,
            frontRightShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightShock".toLowerCase())[0]?.isSelected,
            frontRightSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightSuspension".toLowerCase())[0]?.isSelected,
            frontRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightTyre".toLowerCase())[0]?.isSelected,
            frontTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontTyre".toLowerCase())[0]?.isSelected,
            gasTank: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gasTank".toLowerCase())[0]?.isSelected,
            gearLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gearLever".toLowerCase())[0]?.isSelected,
            gearShifter: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gearShifter".toLowerCase())[0]?.isSelected,
            glassRepairable: undefined,
            handlebars: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-handlebars".toLowerCase())[0]?.isSelected,
            headlight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-headlight".toLowerCase())[0]?.isSelected,
            instruments: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-instruments".toLowerCase())[0]?.isSelected,
            leftFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftFairing".toLowerCase())[0]?.isSelected,
            leftFrontFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftFrontFootrest".toLowerCase())[0]?.isSelected,
            leftIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftIndicator".toLowerCase())[0]?.isSelected,
            leftMirror: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftMirror".toLowerCase())[0]?.isSelected,
            leftRearFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearFootrest".toLowerCase())[0]?.isSelected,
            leftRearIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearIndicator".toLowerCase())[0]?.isSelected,
            leftRearSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearSuspension".toLowerCase())[0]?.isSelected,
            leftShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftShock".toLowerCase())[0]?.isSelected,
            leftSideEngine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideEngine".toLowerCase())[0]?.isSelected,
            leftSideExhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideExhaust".toLowerCase())[0]?.isSelected,
            leftSideFrame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideFrame".toLowerCase())[0]?.isSelected,
            passengerSeat: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-passengerSeat".toLowerCase())[0]?.isSelected,
            rearBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearbrake".toLowerCase())[0]?.isSelected,
            rearBreakLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearBreakLever".toLowerCase())[0]?.isSelected,
            rearFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearFairing".toLowerCase())[0]?.isSelected,
            rearLeftBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftrearbrake".toLowerCase())[0]?.isSelected,
            rearMudguard: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearMudguard".toLowerCase())[0]?.isSelected,
            rearRightBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightrearbrake".toLowerCase())[0]?.isSelected,
            rearShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearShock".toLowerCase())[0]?.isSelected,
            rearTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearTyre".toLowerCase())[0]?.isSelected,
            rightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightFairing".toLowerCase())[0]?.isSelected,
            rightFrontFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightFrontFootrest".toLowerCase())[0]?.isSelected,
            rightIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightIndicator".toLowerCase())[0]?.isSelected,
            rightMirror: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightMirror".toLowerCase())[0]?.isSelected,
            rightRearFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearFootrest".toLowerCase())[0]?.isSelected,
            rightRearIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearIndicator".toLowerCase())[0]?.isSelected,
            rightRearSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearSuspension".toLowerCase())[0]?.isSelected,
            rightShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightShock".toLowerCase())[0]?.isSelected,
            rightSideEngine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideEngine".toLowerCase())[0]?.isSelected,
            rightSideExhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideExhaust".toLowerCase())[0]?.isSelected,
            rightSideFrame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideFrame".toLowerCase())[0]?.isSelected,
            seat: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-seat".toLowerCase())[0]?.isSelected,
            sendAuthToSupplier: undefined,
            shock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-shock".toLowerCase())[0]?.isSelected,
            sprocket: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-sprocket".toLowerCase())[0]?.isSelected,
            suspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-suspension".toLowerCase())[0]?.isSelected,
            tailLight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-tailLight".toLowerCase())[0]?.isSelected,
            windshield: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-windshield".toLowerCase())[0]?.isSelected,
            claimMotorBikeId: undefined,
            id: undefined,
        }
        let claimCarDamage: AddUpdateCarDamageOnClaim = {
            additionalDamageDetail: getState().claimSubmit.extraDescription,
            airbagPopped: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-AirbagPopped".toLowerCase())[0]?.isSelected,
            back: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Back".toLowerCase())[0]?.isSelected,
            backLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeft".toLowerCase())[0]?.isSelected,
            backLeftDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeftDoor".toLowerCase())[0]?.isSelected,
            backLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeftTyre".toLowerCase())[0]?.isSelected,
            backRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRight".toLowerCase())[0]?.isSelected,
            backRightDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRightDoor".toLowerCase())[0]?.isSelected,
            backRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRightTyre".toLowerCase())[0]?.isSelected,
            bonnet: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Bonnet".toLowerCase())[0]?.isSelected,
            boot: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Boot".toLowerCase())[0]?.isSelected,
            damageCauseId: damageCauseId,
            damageCauseOther: "",
            damagedRepaired: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-DamagedRepaired".toLowerCase())[0]?.isSelected,
            damageRepairmentDetail: "",
            front: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Front".toLowerCase())[0]?.isSelected,
            frontLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeft".toLowerCase())[0]?.isSelected,
            frontLeftDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeftDoor".toLowerCase())[0]?.isSelected,
            frontLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeftTyre".toLowerCase())[0]?.isSelected,
            frontRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRight".toLowerCase())[0]?.isSelected,
            frontRightDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRightDoor".toLowerCase())[0]?.isSelected,
            frontRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRightTyre".toLowerCase())[0]?.isSelected,
            frontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Windscreen".toLowerCase())[0]?.isSelected,
            interior: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Interior".toLowerCase())[0]?.isSelected,
            leftBackWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backleftwindow".toLowerCase())[0]?.isSelected,
            leftFrontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-frontleftwindow".toLowerCase())[0]?.isSelected,
            rearWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backwindow".toLowerCase())[0]?.isSelected,
            rightBackWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backrightwindow".toLowerCase())[0]?.isSelected,
            rightFrontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-frontrightwindow".toLowerCase())[0]?.isSelected,
            rolled: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Rolled".toLowerCase())[0]?.isSelected,
            roof: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Roof".toLowerCase())[0]?.isSelected,
            standardPartsDescription: "",
            standardPartsStolen: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-StandardPartsStolen".toLowerCase())[0]?.isSelected,
            sunroof: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Sunroof".toLowerCase())[0]?.isSelected,
            underCarriage: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-undercarriagedamage".toLowerCase())[0]?.isSelected,
            vehicleLocks: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-locks".toLowerCase())[0]?.isSelected,
            claimCarId: undefined,
            claimId: undefined,
            drivable: true,
            id: undefined,
        }

        var driverDetailObj: DriverDetail[] = [];
        if (getState().claimSubmit.claimDriver.isRegularDriver) {
            driverDetailObj.push(getState().claimSubmit.regularDriver)
            if (getState().claimSubmit.riskItemParkingAddress !== "") {
                driverDetailObj[0].addressId = getState().claimSubmit.riskItemParkingAddress.id;
            }
            driverDetailObj[0].copyRegularDriver = true
        }

        var locationDetailObj: ClaimLocation[] = [{
            claimLocationId: null,
            claimLocationTypeId: getState().claimSubmit.claimParkingLocationId,
            addressId: getState().claimSubmit.riskItemParkingAddress === "" ? undefined : getState().claimSubmit.riskItemParkingAddress,
            serviceProviderId: null,
            companyName: "",
            addressLine1: (getState().claimSubmit.addressDetail?.formatted?.length > 0 ? getState().claimSubmit.addressDetail.formatted : (getState().claimSubmit.address?.length > 0 ? getState().claimSubmit.address : "Address not provided")),
            addressLine2: "",
            province: getState().claimSubmit.addressDetail !== null ? getState().claimSubmit.addressDetail.province : "NA",
            city: getState().claimSubmit.addressDetail !== null ? getState().claimSubmit.addressDetail.city : "NA",
            suburb: getState().claimSubmit.addressDetail !== null ? getState().claimSubmit.addressDetail.suburb : "NA",
            countryId: getState().profile.countryId,
            locationId: null,
            locationDescription: getState().claimSubmit.whereDescription != "" ? getState().claimSubmit.whereDescription : "No description",
            other: "",
            friendName: "",
            friendNumber: "",
            postalCode: getState().claimSubmit.addressDetail !== null ? getState().claimSubmit.addressDetail.postalCode : "",
            gripId: "",
            locationType: "",
            howFarFromLand: "",
            assessorPanelbeaterAssessorLocationId: null,
            unknownAddress: false,
            longitude: getState().claimSubmit.addressLon,
            latitude: getState().claimSubmit.addressLat,
            claimOccurrenceLocationId: getState().claimSubmit.claimOccuranceLocation,
        }]

        var addUpdateObj: AddUpdateClaimMessage = {
            claimCarDamage: isCar ? claimCarDamage : undefined,
            claimMotorbikeDamage: isCar ? undefined : claimMotorbikeDamage,
            riskItemId: getState().claimSubmit.selectedRiskItem.id,
            driverDetails: driverDetailObj,
            claimId: undefined,
            policeReported: getState().claimSubmit.policeReportNumber !== "",
            policeCaseNumber: getState().claimSubmit.policeReportNumber,
            policeStation: getState().claimSubmit.policeReportStation,
            claimCar: isCar ? ({
                registrationNumber: getState().claimSubmit.claimVehicleRegNo,
                potholePhoto: getState().claimSubmit.potholePhotoTaken === undefined ? false : getState().claimSubmit.potholePhotoTaken,
                financed: getState().claimSubmit.isVehicleFinanced === "yes" ? true : false,
                financeHouseId: getState().claimSubmit.selectedFinanceHouse === "" ? undefined : getState().claimSubmit.selectedFinanceHouse.id,
                CarDriven: getState().claimSubmit.isStationary === "yes" ? false : true,

            }) : undefined,
            claimMotorbike: isCar ? undefined : ({
                registrationNumber: getState().claimSubmit.claimVehicleRegNo,
                potholePhoto: getState().claimSubmit.potholePhotoTaken === undefined ? false : getState().claimSubmit.potholePhotoTaken,
                financed: getState().claimSubmit.isVehicleFinanced === "yes" ? true : false,
                financeHouseId: getState().claimSubmit.selectedFinanceHouse === "" ? undefined : getState().claimSubmit.selectedFinanceHouse.id,
                MotorbikeDriven: getState().claimSubmit.isStationary === "yes" ? false : true,
            }),
            locations: locationDetailObj,
            needsTraumaCounselling: false
        }
        var claimSubmit: DrivableClaimRequest = {
            performCreateIncident: true,
            performInitiateClaim: true,
            performAddUpdateClaimMessage: true,
            performRegisterClaim: true,
            contactName: getState().claimSubmit.contactPersonFullName,
            contactNumber: getState().claimSubmit.contactPersonNumber,
            createIncident: createIncidentObj,
            initiateClaim: initiateObj,
            addUpdateClaimMessage: addUpdateObj,
            registerClaim: {},
        }
        await postToController(dispatch, 'SubmitDrivableClaim',
            JSON.stringify(claimSubmit)).then(async (response) => {
                if (response !== null) {
                    dispatch({
                        type: SET_CLAIM_DATA, payload: {
                            claimId: response.addedUpdateClaimMessage.claimId,
                        }
                    });
                } else {
                    logErrorToDatabase("SubmitDrivableClaim failed");
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    });
                }
            }).finally(async () => {
                await dispatch(refreshCustomerClaims());
                dispatch(hideLoadingScreen());
            });
    }
}

export const registerDrivableClaim = () => {
    return async (dispatch, getState) => {
        var claimSubmit: DrivableClaimRequest = {
            performCreateIncident: true,
            performInitiateClaim: true,
            performAddUpdateClaimMessage: true,
            performRegisterClaim: true,
            contactName: getState().claimSubmit.contactPersonFullName,
            contactNumber: getState().claimSubmit.contactPersonNumber,
            createIncident: {},
            initiateClaim: {},
            addUpdateClaimMessage: {},
            registerClaim: { claimId: getState().claimSubmit.claimId },
        }
        logEvent('SSP_register_claim', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        await postToController(dispatch, 'SubmitDrivableClaim',
            JSON.stringify(claimSubmit)).then(async (response) => { });
    }
}

export const updateOutcomeOnClaimRepudiate = () => {
    return async (dispatch, getState) => {
        logEvent('SSP_repudiate_claim', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.claimId);
        await postToController(dispatch, 'UpdateOutcomeOnClaimRepudiate', JSON.stringify({
            ClaimId: getState().claimSubmit.claimId,
        })).then((response) => {
            if (!response || response == 'failure') {
                logErrorToDatabase("UpdateOutcomeOnClaimRepudiate failed");
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                return;
            }
            dispatch(refreshCustomerClaims());
            dispatch(navigateTo(CLAIM_END_PAGE));
            dispatch(showModalDrivableCloseClaim());
        }).catch((err) => {
            logErrorToDatabase("UpdateOutcomeOnClaimRepudiate failed");
            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        })
    }
}

export const addTraumaCouncelling = () => {
    return async (dispatch, getState) => {
        let riskItemId = getState().claimSubmit.selectedRiskItem?.id ?? getState().profile.selectedPersonalClaim.riskItemDetails.id;
        let claimId = (getState().claimSubmit.claimId && getState().claimSubmit.claimId !== "") ? getState().claimSubmit.claimId : getState().profile.selectedPersonalClaim.claimID;

        let request = {
            riskItemId: riskItemId,
            claimId: claimId,
            needsTraumaCounselling: true
        } as AddTraumaCounsellingRequest;

        await postToController(dispatch, 'AddTraumaCounsellingToClaim',
            JSON.stringify(request)).then(async (response) => {
                if (response === null) {
                    logErrorToDatabase("AddTraumaCounsellingToClaim failed");
                    dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    });
                }
            });
    }
}
//#endregion

//#region followupClaims
export const updateClaimPartyReducer = (partyType: any, operation: string, id = 0, thirdParty: any = null) => {
    return async (dispatch, getState) => {
        let otherParties = [] as IThirdParty[];
        let retrievalConfig = otherPartyRetrievalConfig.find(x => x.configType === partyType) as any;
        otherParties = getState().claimSubmit[retrievalConfig.reduxRetrievalName] as IThirdParty[];
        let reducerName = retrievalConfig.reduxRetrievalName;

        if (!otherParties) {
            otherParties = [];
        }

        if (operation === 'add') {
            let partyId = 1;
            if (otherParties.length > 0) {
                partyId = otherParties[otherParties.length - 1].id + 1;
            }

            let newOtherParty: IThirdParty = {
                id: partyId,
                driverType: partyType,
                thirdPartyId: undefined,
                thirdPartyTypeId: partyTypeMapping.find(x => x.partyType == partyType)?.id ?? THIRDPARTY_TYPE_OTHER_ID,
                firstName: "",
                surname: "",
                idNumber: "",
                contactNumber: "",
                email: "",
                vehicleDescription: "",
                vehicleDamageDescription: "",
                registrationNumber: "",
                claimThirdPartyIsInsuredOptionId: undefined,
                insuranceCompanyId: undefined,
                otherInsuranceCompany: "",
                otherThirdPartyDetail: "",
                locationDescription: "",
                postalCode: "",
                checklistFlag: false,
                dateOfBirth: undefined,
                hasInsurance: "",
                isInjured: false
            }
            otherParties.push(newOtherParty);
        }
        else if (operation === 'edit') {
            otherParties = otherParties.map((item) => {
                if (item.id == thirdParty.id) {
                    item.firstName = thirdParty.firstName;
                    item.surname = thirdParty.surname;
                    item.contactNumber = thirdParty.contactNumber;
                    item.email = thirdParty.email;
                    item.idNumber = thirdParty.idNumber;
                    item.registrationNumber = thirdParty.registrationNumber;
                    item.vehicleDescription = thirdParty.vehicleDescription;
                    item.vehicleDamageDescription = thirdParty.vehicleDamageDescription;
                    item.otherInsuranceCompany = thirdParty.otherInsuranceCompany;
                    item.insuranceCompanyId = thirdParty.insuranceCompanyId;
                    item.hasInsurance = thirdParty.hasInsurance;
                    item.isInjured = thirdParty.isInjured;
                }
                return item;
            });
        }
        else if (operation === 'remove') {
            otherParties = otherParties.filter(x => x.id !== id)
        }
        else if (operation === 'clear') {
            otherParties = [];
        }

        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                [reducerName]: otherParties,
            }
        });
    }
}

export const checkClaimPartyModalShow = (partyConfig: IThirdPartyConfig, flagReducerName: any) => {
    return async (dispatch, getState) => {
        let otherParties = [] as IThirdParty[];
        let retrievalConfig = otherPartyRetrievalConfig.find(x => x.configType === partyConfig.thirdPartyConfigType) as any;
        otherParties = getState().claimSubmit[retrievalConfig.reduxRetrievalName] as IThirdParty[];
        let reducerName = retrievalConfig.reduxRetrievalName;
        if (!otherParties) {
            otherParties = [];
        }

        var hasValues = await dispatch(checkPartyTypeHasValues(partyConfig));
        if (hasValues) {
            dispatch(showModalClearParty(partyConfig.thirdPartyConfigType, flagReducerName))
        }
        else {
            dispatch(setFnolReducer(flagReducerName, false))
            await dispatch({
                type: SET_CLAIM_DATA, payload: {
                    [reducerName]: [],
                }
            });
        }
    }
}

export const validateClaimParties = (partyConfig: IThirdPartyConfig) => {
    return async (dispatch, getState) => {
        let otherParties = [] as IThirdParty[];
        let retrievalConfig = otherPartyRetrievalConfig.find(x => x.configType === partyConfig.thirdPartyConfigType) as any;
        otherParties = getState().claimSubmit[retrievalConfig.reduxRetrievalName] as IThirdParty[];

        if (!otherParties) {
            otherParties = [];
        }
        let errorList = [] as Array<any>;
        let counter = 1;
        otherParties.map((item) => {
            let hasError = false;

            hasError = (partyConfig.firstNameValidation && !item.firstName) ? true : hasError;
            hasError = (partyConfig.surnameValidation && !item.surname) ? true : hasError;
            hasError = (partyConfig.contactNumberValidation && (!item.contactNumber)) ? true : hasError;
            hasError = (partyConfig.emailValidation && !item.email) ? true : hasError;
            hasError = ((partyConfig.contactNumberOrEmailValidation) && (!item.contactNumber && !item.email)) ? true : hasError;
            hasError = (partyConfig.registrationNumberValidation && !item.registrationNumber && item.thirdPartyTypeId === THIRDPARTY_TYPE_OTHER_ID) ? true : hasError;
            hasError = (partyConfig.idNumberValidation && !item.idNumber) ? true : hasError;
            hasError = (partyConfig.vehicleDescriptionValidation && !item.vehicleDescription) ? true : hasError;
            hasError = (partyConfig.vehicleDamageDescriptionValidation && !item.vehicleDamageDescription) ? true : hasError;
            hasError = (partyConfig.hasInsuranceValidation && !item.hasInsurance) ? true : hasError;
            hasError = (partyConfig.hasInsuranceValidation && item.hasInsurance == "true" && !item.insuranceCompanyId) ? true : hasError;

            //Regex validation
            let invalidStr = '';
            if (item.contactNumber && !validateCellphoneNumber.test(item.contactNumber)) {
                hasError = true;
                invalidStr += 'contactNumber|';
            }
            if (item.email && !validateEmail.test(item.email)) {
                hasError = true;
                invalidStr += 'email|';
            }
            if (item.idNumber && !validateIdNumber.test(item.idNumber)) {
                hasError = true;
                invalidStr += 'idNumber|'
            }

            let duplicateStr = '';
            let allParties = [] as Array<IThirdParty>;
            allParties = allParties.concat(getState().claimSubmit.otherThirdParties as IThirdParty[],
                getState().claimSubmit.witnesses as IThirdParty[],
                getState().claimSubmit.pedestrians as IThirdParty[],
                getState().claimSubmit.passengers as IThirdParty[]);

            if (allParties.find(x => (x.contactNumber !== "" && ((x.contactNumber == item.contactNumber && x.driverType != partyConfig.thirdPartyConfigType) || (x.contactNumber == item.contactNumber && x.driverType == partyConfig.thirdPartyConfigType && x.id < item.id))))) {
                duplicateStr += 'contactNumber'
            }
            if (allParties.find(x => (x.email !== "" && ((x.email == item.contactNumber && x.driverType != partyConfig.thirdPartyConfigType) || (x.email == item.email && x.driverType == partyConfig.thirdPartyConfigType && x.id < item.id))))) {
                duplicateStr += 'email'
            }
            if (allParties.find(x => (x.idNumber !== "" && ((x.idNumber == item.idNumber && x.driverType != partyConfig.thirdPartyConfigType) || (x.idNumber == item.idNumber && x.driverType == partyConfig.thirdPartyConfigType && x.id < item.id))))) {
                duplicateStr += 'idNumber'
            }
            if (hasError || duplicateStr != '') {
                errorList.push({
                    id: counter, type: item.driverType, duplicate: duplicateStr, invalid: invalidStr
                });
            }
            counter++;
        });

        if (!errorList) {
            errorList = [];
        }
        return errorList;
    }
}

export const checkPartyTypeHasValues = (partyConfig: IThirdPartyConfig) => {
    return async (dispatch, getState) => {
        let otherParties = [] as IThirdParty[];
        let retrievalConfig = otherPartyRetrievalConfig.find(x => x.configType === partyConfig.thirdPartyConfigType) as any;
        otherParties = getState().claimSubmit[retrievalConfig.reduxRetrievalName] as IThirdParty[];
        if (!otherParties) {
            otherParties = [];
        }
        let hasValues = false;
        if (otherParties.length != 0) {
            hasValues = otherParties.filter(item => item.contactNumber !== "" || item.email !== "" || item.firstName !== "" || item.hasInsurance !== "" || item.idNumber !== "" || item.hasInsurance !== "" || item.registrationNumber !== "" || item.surname !== "" || item.vehicleDamageDescription !== "" || item.vehicleDescription !== "").length > 0;
        }
        return hasValues;
    }
}

export const checkDuplicateFields = (partyType: string, field: string, id: any, value: any) => {
    return async (dispatch, getState) => {
        let allParties = [] as Array<IThirdParty>;
        allParties = allParties.concat(getState().claimSubmit.otherThirdParties as IThirdParty[],
            getState().claimSubmit.witnesses as IThirdParty[],
            getState().claimSubmit.pedestrians as IThirdParty[],
            getState().claimSubmit.passengers as IThirdParty[]);

        var isDuplicate = false;
        if (allParties.find(x => (x[field] !== undefined && x[field] !== "" && (x[field] == value && x.driverType != partyType) || (x[field] == value && x.driverType == partyType && x.id != id)))) {
            isDuplicate = true;
        }
        return isDuplicate ? field : "";
    }
}

export const setRegularDriverDropdown = () => {
    return async (dispatch, getState) => {
        await postToController(dispatch, 'GetRegularDriver', JSON.stringify({ Parameter: getState().claimSubmit.selectedRiskItem.id })).then(async (regularDriverResponse) => {
            var regularDriver = {
                isPolicyHolder: (getState().profile.idNumber == regularDriverResponse.idNumber),
                isRegularDriver: true,
                name: regularDriverResponse.firstName,
                surname: regularDriverResponse.surname,
                idNumber: regularDriverResponse.idNumber,
                order: 1
            } as RegularDriverDropdownItem;
            var otherDriver = {
                isPolicyHolder: false,
                isRegularDriver: false,
                name: 'None of the listed drivers',
                surname: '',
                idNumber: '',
                order: 3
            } as RegularDriverDropdownItem;

            var dropdownList = [] as Array<RegularDriverDropdownItem>;
            dropdownList.push(regularDriver);
            dropdownList.push(otherDriver);
            dispatch({
                type: SET_CLAIM_DATA, payload: {
                    regularDriver: regularDriverResponse,
                    driverDropdown: dropdownList,
                }
            });
        })
    }
}

export const submitFollowUpQuestions = () => {
    return async (dispatch, getState) => {
        await dispatch({ type: LOADING_SCREEN_SHOW });
        logEvent('SSP_submit_claim_follow_up', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.claimId);
        let passengerList = [];
        let witnessList = [];
        let pedestrianList = [];
        let otherPartyList = [];
        if (getState().claimSubmit.passengers.length > 0) {
            passengerList = getState().claimSubmit.passengers.map((item) => {
                return {
                    claimId: getState().claimSubmit.claimId,
                    partyDetails: {
                        contactNumber: item.contactNumber,
                        firstName: item.firstName,
                        idNumber: item.idNumber,
                        claimPartyTypeId: 1,
                        emailAddress: item.email,
                        homeNumber: "",
                        surname: item.surname,
                        witnessPositioning: "",
                        relationshipToInsured: "",
                        workNumber: "",
                        partyDetailId: undefined,
                        preferredContactMethodId: undefined,
                        preferredContactTimeId: undefined,
                        IsInjured: item.isInjured,
                    }
                };
            });
        }

        if (getState().claimSubmit.witnesses.length > 0) {
            witnessList = getState().claimSubmit.witnesses.map((item) => {
                return {
                    claimId: getState().claimSubmit.claimId,
                    partyDetails: {
                        contactNumber: item.contactNumber,
                        firstName: item.firstName,
                        idNumber: item.idNumber,
                        claimPartyTypeId: 2,
                        emailAddress: item.email,
                        homeNumber: "",
                        surname: item.surname,
                        witnessPositioning: "",
                        relationshipToInsured: "",
                        workNumber: "",
                        partyDetailId: undefined,
                        preferredContactMethodId: undefined,
                        preferredContactTimeId: undefined,
                        IsInjured: item.isInjured,
                    }
                };
            });
        }

        if (getState().claimSubmit.pedestrians.length > 0) {
            pedestrianList = getState().claimSubmit.pedestrians.map((item) => {
                return {
                    claimId: getState().claimSubmit.claimId,
                    partyDetails: {
                        contactNumber: item.contactNumber,
                        firstName: item.firstName,
                        idNumber: item.idNumber,
                        claimPartyTypeId: 8,
                        emailAddress: item.email,
                        homeNumber: "",
                        surname: item.surname,
                        witnessPositioning: "",
                        relationshipToInsured: "",
                        workNumber: "",
                        partyDetailId: undefined,
                        preferredContactMethodId: undefined,
                        preferredContactTimeId: undefined,
                        IsInjured: item.isInjured,
                    }
                };
            });
        }

        if (getState().claimSubmit.otherThirdParties.length > 0) {
            otherPartyList = getState().claimSubmit.otherThirdParties.map((item) => {
                return {
                    claimId: getState().claimSubmit.claimId,
                    thirdPartyDetail: {
                        thirdPartyTypeId: 1,
                        contactNumber: item.contactNumber,
                        firstName: item.firstName,
                        idNumber: item.idNumber,
                        email: item.email,
                        surname: item.surname,
                        checklistFlag: false,
                        claimThirdPartyIsInsuredOptionId: item.hasInsurance == "true" ? CLAIM_THIRD_PARTY_INSURED_YES : item.hasInsurance == "false" ? CLAIM_THIRD_PARTY_INSURED_NO : CLAIM_THIRD_PARTY_INSURED_NOT_SURE,
                        insuranceCompanyId: item.insuranceCompanyId ?? undefined,
                        otherInsuranceCompany: "",
                        otherThirdPartyDetail: item.otherThirdPartyDetail,
                        registrationNumber: item.registrationNumber,
                        vehicleDamageDescription: item.vehicleDamageDescription,
                        vehicleDescription: item.vehicleDescription,
                    }
                } as IThirdPartyToClaim;
            });
        }

        let claimMotorbikeDamage: AddUpdateMotorBikeDamageOnClaim = {
            additionalDamageDetail: getState().claimSubmit.extraDescription,
            axle: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-axle".toLowerCase())[0]?.isSelected,
            back: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-back".toLowerCase())[0]?.isSelected,
            backCarrier: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backCarrier".toLowerCase())[0]?.isSelected,
            backLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backLeft".toLowerCase())[0]?.isSelected,
            backLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backLeftTyre".toLowerCase())[0]?.isSelected,
            backRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRight".toLowerCase())[0]?.isSelected,
            backRightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRightFairing".toLowerCase())[0]?.isSelected,
            backLeftFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backLeftFairing".toLowerCase())[0]?.isSelected,
            backRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-backRightTyre".toLowerCase())[0]?.isSelected,
            chain: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-chain".toLowerCase())[0]?.isSelected,
            claimId: undefined,
            carrier: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-carrier".toLowerCase())[0]?.isSelected,
            clutchLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-clutchLever".toLowerCase())[0]?.isSelected,
            damageCauseOther: undefined,
            damagedRepaired: undefined,
            damageRepairmentDetail: undefined,
            drivable: true,
            driveTrain: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-driveTrain".toLowerCase())[0]?.isSelected,
            engine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-engine".toLowerCase())[0]?.isSelected,
            exhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-exhaust".toLowerCase())[0]?.isSelected,
            frame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frame".toLowerCase())[0]?.isSelected,
            front: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-front".toLowerCase())[0]?.isSelected,
            frontBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontbrake".toLowerCase())[0]?.isSelected,
            frontFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftFairing".toLowerCase())[0]?.isSelected,
            frontLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeft".toLowerCase())[0]?.isSelected,
            frontLeftBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontleftbrake".toLowerCase())[0]?.isSelected,
            frontLeftFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftFairing".toLowerCase())[0]?.isSelected,
            frontLeftShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftShock".toLowerCase())[0]?.isSelected,
            frontLeftSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftSuspension".toLowerCase())[0]?.isSelected,
            frontLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontLeftTyre".toLowerCase())[0]?.isSelected,
            frontMudguard: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontMudguard".toLowerCase())[0]?.isSelected,
            frontRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRight".toLowerCase())[0]?.isSelected,
            frontRightBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightfrontbrake".toLowerCase())[0]?.isSelected,
            frontRightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightFairing".toLowerCase())[0]?.isSelected,
            frontRightShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightShock".toLowerCase())[0]?.isSelected,
            frontRightSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightSuspension".toLowerCase())[0]?.isSelected,
            frontRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontRightTyre".toLowerCase())[0]?.isSelected,
            frontTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-frontTyre".toLowerCase())[0]?.isSelected,
            gasTank: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gasTank".toLowerCase())[0]?.isSelected,
            gearLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gearLever".toLowerCase())[0]?.isSelected,
            gearShifter: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-gearShifter".toLowerCase())[0]?.isSelected,
            glassRepairable: undefined,
            handlebars: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-handlebars".toLowerCase())[0]?.isSelected,
            headlight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-headlight".toLowerCase())[0]?.isSelected,
            instruments: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-instruments".toLowerCase())[0]?.isSelected,
            leftFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftFairing".toLowerCase())[0]?.isSelected,
            leftFrontFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftFrontFootrest".toLowerCase())[0]?.isSelected,
            leftIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftIndicator".toLowerCase())[0]?.isSelected,
            leftMirror: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftMirror".toLowerCase())[0]?.isSelected,
            leftRearFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearFootrest".toLowerCase())[0]?.isSelected,
            leftRearIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearIndicator".toLowerCase())[0]?.isSelected,
            leftRearSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftRearSuspension".toLowerCase())[0]?.isSelected,
            leftShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftShock".toLowerCase())[0]?.isSelected,
            leftSideEngine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideEngine".toLowerCase())[0]?.isSelected,
            leftSideExhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideExhaust".toLowerCase())[0]?.isSelected,
            leftSideFrame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftSideFrame".toLowerCase())[0]?.isSelected,
            passengerSeat: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-passengerSeat".toLowerCase())[0]?.isSelected,
            rearBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearbrake".toLowerCase())[0]?.isSelected,
            rearBreakLever: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearBreakLever".toLowerCase())[0]?.isSelected,
            rearFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearFairing".toLowerCase())[0]?.isSelected,
            rearLeftBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-leftrearbrake".toLowerCase())[0]?.isSelected,
            rearMudguard: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearMudguard".toLowerCase())[0]?.isSelected,
            rearRightBreak: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightrearbrake".toLowerCase())[0]?.isSelected,
            rearShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearShock".toLowerCase())[0]?.isSelected,
            rearTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rearTyre".toLowerCase())[0]?.isSelected,
            rightFairing: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightFairing".toLowerCase())[0]?.isSelected,
            rightFrontFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightFrontFootrest".toLowerCase())[0]?.isSelected,
            rightIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightIndicator".toLowerCase())[0]?.isSelected,
            rightMirror: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightMirror".toLowerCase())[0]?.isSelected,
            rightRearFootrest: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearFootrest".toLowerCase())[0]?.isSelected,
            rightRearIndicator: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearIndicator".toLowerCase())[0]?.isSelected,
            rightRearSuspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightRearSuspension".toLowerCase())[0]?.isSelected,
            rightShock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightShock".toLowerCase())[0]?.isSelected,
            rightSideEngine: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideEngine".toLowerCase())[0]?.isSelected,
            rightSideExhaust: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideExhaust".toLowerCase())[0]?.isSelected,
            rightSideFrame: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-rightSideFrame".toLowerCase())[0]?.isSelected,
            seat: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-seat".toLowerCase())[0]?.isSelected,
            sendAuthToSupplier: undefined,
            shock: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-shock".toLowerCase())[0]?.isSelected,
            sprocket: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-sprocket".toLowerCase())[0]?.isSelected,
            suspension: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-suspension".toLowerCase())[0]?.isSelected,
            tailLight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-tailLight".toLowerCase())[0]?.isSelected,
            windshield: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "bike-windshield".toLowerCase())[0]?.isSelected,
            claimMotorBikeId: undefined,
            id: undefined,
            claimGuiltyParty: getState().claimSubmit.claimGuiltyParty,
            damageCauseId: getState().claimSubmit.damageCauseId,
            hasWitnesses: getState().claimSubmit.hasWitnesses,
            hasThirdParties: getState().claimSubmit.hasThirdParties,
            hasPassanger: getState().claimSubmit.hasPassanger,
            thirdPartyUnknownReason: getState().claimSubmit.thirdPartyUnknownReason,
        }

        let claimCarDamage: AddUpdateCarDamageOnClaim = {
            additionalDamageDetail: getState().claimSubmit.extraDescription,
            airbagPopped: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-AirbagPopped".toLowerCase())[0]?.isSelected,
            back: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Back".toLowerCase())[0]?.isSelected,
            backLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeft".toLowerCase())[0]?.isSelected,
            backLeftDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeftDoor".toLowerCase())[0]?.isSelected,
            backLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackLeftTyre".toLowerCase())[0]?.isSelected,
            backRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRight".toLowerCase())[0]?.isSelected,
            backRightDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRightDoor".toLowerCase())[0]?.isSelected,
            backRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-BackRightTyre".toLowerCase())[0]?.isSelected,
            bonnet: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Bonnet".toLowerCase())[0]?.isSelected,
            boot: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Boot".toLowerCase())[0]?.isSelected,
            damageCauseOther: "",
            damagedRepaired: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-DamagedRepaired".toLowerCase())[0]?.isSelected,
            damageRepairmentDetail: "",
            front: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Front".toLowerCase())[0]?.isSelected,
            frontLeft: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeft".toLowerCase())[0]?.isSelected,
            frontLeftDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeftDoor".toLowerCase())[0]?.isSelected,
            frontLeftTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontLeftTyre".toLowerCase())[0]?.isSelected,
            frontRight: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRight".toLowerCase())[0]?.isSelected,
            frontRightDoor: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRightDoor".toLowerCase())[0]?.isSelected,
            frontRightTyre: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-FrontRightTyre".toLowerCase())[0]?.isSelected,
            frontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Windscreen".toLowerCase())[0]?.isSelected,
            interior: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Interior".toLowerCase())[0]?.isSelected,
            leftBackWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backleftwindow".toLowerCase())[0]?.isSelected,
            leftFrontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-frontleftwindow".toLowerCase())[0]?.isSelected,
            rearWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backwindow".toLowerCase())[0]?.isSelected,
            rightBackWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-backrightwindow".toLowerCase())[0]?.isSelected,
            rightFrontWindow: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-frontrightwindow".toLowerCase())[0]?.isSelected,
            rolled: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Rolled".toLowerCase())[0]?.isSelected,
            roof: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Roof".toLowerCase())[0]?.isSelected,
            standardPartsDescription: "",
            standardPartsStolen: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-StandardPartsStolen".toLowerCase())[0]?.isSelected,
            sunroof: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-Sunroof".toLowerCase())[0]?.isSelected,
            underCarriage: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-undercarriagedamage".toLowerCase())[0]?.isSelected,
            vehicleLocks: getState().claimSubmit.claimDamagePhotoTypes.filter(x => x.imageName == "car-locks".toLowerCase())[0]?.isSelected,
            claimCarId: undefined,
            claimId: undefined,
            drivable: true,
            id: undefined,
            claimGuiltyParty: getState().claimSubmit.claimGuiltyParty,
            damageCauseId: getState().claimSubmit.damageCauseId,
            hasWitnesses: getState().claimSubmit.hasWitnesses,
            hasThirdParties: getState().claimSubmit.hasThirdParties,
            hasPassanger: getState().claimSubmit.hasPassanger,
            thirdPartyUnknownReason: getState().claimSubmit.thirdPartyUnknownReason,
        }

        var driverDetailObj: DriverDetail[] = [];
        if (getState().claimSubmit.claimDriver.isRegularDriver) {
            driverDetailObj.push(getState().claimSubmit.regularDriver)
        }

        var carForClaim = {
            ClaimId: getState().claimSubmit.claimId,
            RoadSurfaceId: getState().claimSubmit.selectedRoadSurfaceTypes === "" ? undefined : getState().claimSubmit.selectedRoadSurfaceTypes,
            RoadConditionId: getState().claimSubmit.selectedRoadConditions === "" ? undefined : getState().claimSubmit.selectedRoadConditions,
            PotholePhoto: getState().claimSubmit.potholePhotoTaken === undefined ? false : getState().claimSubmit.potholePhotoTaken,
        };
        var motorbikeForClaim = {
            ClaimId: getState().claimSubmit.claimId,
            RoadSurfaceId: getState().claimSubmit.selectedRoadSurfaceTypes === "" ? undefined : getState().claimSubmit.selectedRoadSurfaceTypes,
            RoadConditionId: getState().claimSubmit.selectedRoadConditions === "" ? undefined : getState().claimSubmit.selectedRoadConditions,
            PotholePhoto: getState().claimSubmit.potholePhotoTaken === undefined ? false : getState().claimSubmit.potholePhotoTaken,
        };
        var addUpdateObj: AddUpdateClaimMessage = {
            claimCarDamage: getState().claimSubmit.isCar ? claimCarDamage : undefined,
            claimMotorbikeDamage: getState().claimSubmit.isCar ? undefined : claimMotorbikeDamage,
            riskItemId: getState().claimSubmit.selectedRiskItem.id,
            driverDetails: driverDetailObj,
            claimId: getState().claimSubmit.claimId,
            policeReported: getState().claimSubmit.policeReportNumber != '',
            policeCaseNumber: getState().claimSubmit.policeReportNumber,
            policeStation: getState().claimSubmit.policeReportStation,
            claimCar: getState().claimSubmit.isCar ? carForClaim : undefined,
            claimMotorbike: getState().claimSubmit.isCar ? undefined : motorbikeForClaim,
            hasWitnesses: getState().claimSubmit.hasWitnesses,
            hasThirdParties: getState().claimSubmit.hasThirdParties,
            hasPassanger: getState().claimSubmit.hasPassanger,
            thirdPartyUnknownReason: getState().claimSubmit.thirdPartyUnknownReason,
            needsTraumaCounselling: false,
            locations: [],
        };

        await postToController(dispatch, 'SubmitFollowUpQuestions',
            JSON.stringify({
                AddUpdateClaimMessage: addUpdateObj,
                AddAdditionalPartyToClaims: passengerList.concat(witnessList).concat(pedestrianList),
                AddThirdPartyToClaims: otherPartyList,
                IsDriverInjured: getState().claimSubmit.isDriverInjured
            }))
            .then(async response => {
                if (response === null || response?.ErrorList != null) {
                    await dispatch({
                        type: MODAL_SHOW,
                        modalProps: {
                            type: MODAL_TYPE_ERROR,
                            header: ERROR_HEADER,
                            body: ERROR_SOMETHING_WENT_WRONG,
                        }
                    });
                    await dispatch(navigateTo(DASHBOARD));
                } else {
                    dispatch({
                        type: MODAL_HIDE,
                        modalProps: {
                            type: MODAL_TYPE_SUCCESS,
                            visible: false,
                        }
                    });
                    let selectedRiskItem = getState().claimSubmit.selectedRiskItem;
                    await dispatch({ type: RESET_CLAIM_DATA, payload: {} });
                    await dispatch({ type: SET_CLAIM_DATA, payload: { selectedRiskItem } });
                    await dispatch(navigateTo(CLAIM_END_PAGE));
                }
            })
            .catch(err => logErrorToDatabase("Error logging SubmitFollowUpQuestions:" + err))
        await dispatch({ type: LOADING_SCREEN_HIDE });
    }
}
//#endregion

//#region to be replace by setClaimData payload function
export const setFnolReducer = (name, value) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                [name]: value
            }
        });
    }
}

export const setStationary = (isStationaryValue) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                isStationary: isStationaryValue
            }
        });

        if (isStationaryValue === 'yes') {
            dispatch({
                type: SET_STEPS_DRIVABLE_STATIONARY, payload: {}
            });
        }
        else {
            dispatch({
                type: SET_STEPS_DRIVABLE, payload: {}
            });
        }
    }
}

export const setClaimDriver = (driverValue) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                claimDriver: driverValue
            }
        });
    }
}

export const setVehicleRegConfirm = (vehicleRegConfirmValue) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                vehicleRegistrationConfirm: vehicleRegConfirmValue
            }
        });
    }
}

export const setVehicleRegNumber = (vehicleRegValue) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                claimVehicleRegNo: vehicleRegValue
            }
        });
    }
}

export const setIsFinanced = (isVehicleFinancedValue) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                isVehicleFinanced: isVehicleFinancedValue
            }
        });
    }
}

export const setSelectedFinanceHouse = (financeHouseValue) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                selectedFinanceHouse: financeHouseValue
            }
        });
    }
}

export const setPoliceReportNumber = (reportNumber: string) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                policeReportNumber: reportNumber,
            }
        });
    }
}

export const setPoliceReportStation = (reportStation: string) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                policeReportStation: reportStation,
            }
        });
    }
}

export const setDefaultDispayTime = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                timeDisplay: "12:00 pm"
            }
        });
    }
}

export const setDisclaimer = (flag) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                showDisclaimer: flag
            }
        });
    }
}

export const setLatLonAddress = (lat, lon, address) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                addressLat: lat,
                addressLon: lon,
                address: address
            }
        });
        return true;
    }
}

export const setIsRepaired = (repaired) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                isRepaired: repaired,
                glassSubmitDisabled: false,
            }
        });
    }
}

export const setHasSmashAndGrab = (repaired) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                hasSmashAndGrab: repaired,
            }
        });
    }
}

export const setHasBeenRepaired = (repaired) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                hasBeenRepaired: repaired,
            }
        });
    }
}

export const setCanBeenRepaired = (repaired) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                glassDamage: repaired,
            }
        });
    }
}

export const setRepairStepValid = (isValid) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                repairStepValid: isValid,
            }
        });
    }
}

export const setRiskItemAndIncident = (riskItem: any, IncidentType: any) => {
    return async (dispatch, getState) => {
        var isCar = true;
        if (riskItem.product !== MOTOR_COMPREHENSIVE_PRODUCT_ID && riskItem.product !== CHILLI_COMPREHENSIVE_PRODUCT_ID) {
            isCar = false
        }
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                selectedRiskItem: riskItem,
                incidentType: IncidentType,
                isCar: isCar,
            }
        });
    }
}

export const setFNOLDetails = (IncidentEventType: any, IncidentDate: any, IncidentTime: any, ContactName: any, ContactNumber: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                incidentEventType: IncidentEventType,
                indidentDate: IncidentDate,
                incidentTime: IncidentTime,
                contactName: ContactName,
                contactNumber: ContactNumber,
            }
        });
    }
}

export const setFNOLLocation = (WhereDescription: any, Address: any, AddressLat: any, AddressLon: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                whereDescription: WhereDescription,
                address: Address,
                addressLat: AddressLat,
                addressLon: AddressLon
            }
        });
    }
}

export const setFNOLWhat = (WhatDescription: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                whatDescription: WhatDescription,
            }
        });
    }
}

export const setFNOLDrivable = (IsDriveavle: boolean) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                isDriveavle: IsDriveavle,
            }
        });
    }
}

export const setIsCar = (isCar: boolean) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                isCar: isCar,
            }
        });
    }
}

export const setIsInEdit = (isEdit: boolean) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                isInEdit: isEdit,
            }
        });
    }
}

export const setFnolIncidentEventList = (ListData, Event) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                incidentEventList: ListData,
                incidentType: Event
            }
        });
    }
}

export const setInfoFromFNOL = (step: any, riskItem: any, event: any) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                currentStep: step,
                selectedCover: riskItem,
                selectedEvent: event
            }
        });
    }
}

export const setCoverFromPersonalInsurance = (riskItem: any) => {
    return async (dispatch, getState) => {
        var isCar = true;
        if (riskItem.product !== MOTOR_COMPREHENSIVE_PRODUCT_ID && riskItem.product !== CHILLI_COMPREHENSIVE_PRODUCT_ID) {
            isCar = false
        }
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                fromPersonalSubmit: true,
                selectedCover: riskItem,
            }
        });
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                selectedRiskItem: riskItem,
                incidentType: null,
                isCar: isCar,
            }
        });
    }
}

export const resetCoverItem = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                selectedCover: [],
            }
        });
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                selectedRiskItem: [],
            }
        });
    }
}

export const resetFromPersonalSubmit = () => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                fromPersonalSubmit: false,
            }
        });
    }
}

export const setClaimsStep = (step) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                currentStep: step,
            }
        });
    }
}

export const setData = (userData: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                name: userData.name,
                number: userData.number,
                incidentDescription: userData.incidentDescription,
                incidentDate: userData.incidentDate,
                incidentEventType: userData.incidentEventType,
                isDrivable: userData.isDrivable,
                isRecovered: userData.isRecovered,
            }
        });
    }
}

export const setLocation = (Lat: any, Lng: any) => {
    return async (dispatch, getState) => {
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                lat: Lat,
                lon: Lng,
            }
        });
        return true;
    }
}

export const setDate = (e: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                incidentDate: e,
            }
        });
        return true;
    }
}

export const resetDate = () => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                incidentDate: "",
            }
        });
        return true;
    }
}


export const setclaimV2Details = (IncidentEventType: any, IncidentDate: any, IncidentTime: any, ContactName: any, ContactNumber: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                incidentEventType: IncidentEventType,
                indidentDate: IncidentDate,
                incidentTime: IncidentTime,
                contactName: ContactName,
                contactNumber: ContactNumber,
            }
        });
    }
}

export const setclaimV2Location = (WhereDescription: any, Address: any, AddressLat: any, AddressLon: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                whereDescription: WhereDescription,
                adress: Address,
                addressLat: AddressLat,
                addressLon: AddressLon
            }
        });
    }
}

export const setclaimV2What = (WhatDescription: any) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                whatDescription: WhatDescription,
            }
        });
    }
}

export const setclaimV2Drivable = (IsDriveavle: boolean) => {
    return async (dispatch, getState) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                isDriveavle: IsDriveavle,
            }
        });
    }
}

export const showclaimV2TakePhoto = (description: string) => {
    return async (dispatch, getState) => {
        var photoList = getState().claimSubmit.claimDamagePhotoTypes
        for (var i = 0; i < photoList.length; i++) {
            if (photoList[i].description.toLowerCase() === description.toLowerCase()) {
                await dispatch({
                    type: SET_CLAIM_DATA, payload: {
                        selectedDamagePhotoTypes: photoList[i],
                    },
                });
                break;
            }
        }
    }
}

export const saveClaimV2Photo = (description: string, photo: string) => {
    return async (dispatch, getState) => {
        var photoList = getState().claimSubmit.claimDamagePhotoTypes
        for (var i = 0; i < photoList.length; i++) {
            if (photoList[i].description.toLowerCase() === description.toLowerCase()) {
                photoList[i].photoData = photo;
                break;
            }
        }
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                claimDamagePhotoTypes: photoList,
            },
        });
    }
}

export const setDriverType = (type: string) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                driverType: type,
            }
        });
    }
}

export const setPolcyAndType = (userData: any) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                fnolStep: userData
            }
        });
    }
}
//#endregion

//#region claimConfigs
export const partyTypeMapping = [{
    partyType: THIRDPARTY_TYPE_OTHER,
    id: 12
},
{
    partyType: THIRDPARTY_TYPE_WITNESS,
    id: 12
},
{
    partyType: THIRDPARTY_TYPE_PEDESTRIAN,
    id: 8
},
{
    partyType: THIRDPARTY_TYPE_PASSENGER,
    id: 2
}];

export const otherPartyRetrievalConfig = [{
    configType: THIRDPARTY_TYPE_OTHER,
    reduxRetrievalName: 'otherThirdParties',
},
{
    configType: THIRDPARTY_TYPE_WITNESS,
    reduxRetrievalName: 'witnesses',
},
{
    configType: THIRDPARTY_TYPE_PEDESTRIAN,
    reduxRetrievalName: 'pedestrians',
},
{
    configType: THIRDPARTY_TYPE_PASSENGER,
    reduxRetrievalName: 'passengers',
}];
//#endregion

//#region rework navigation to one method with file & folder restructure
export const setGlassStep = (step: number, subStep: 1) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                glassStep: step,
                glassSubStep: subStep
            }
        });
    }
}

export const completeGlassStep = () => {
    return async (dispatch, getState) => {
        var step = getState().claimSubmit.glassStep;
        var subStep = getState().claimSubmit.glassSubStep;
        var lastStep = getState().claimSubmit.lastCompletedGlassStep;
        var lastSubStep = getState().claimSubmit.lastCompletedGlassSubStep;
        if (step + (subStep / 10) > lastStep + (lastSubStep / 10)) {
            lastStep = step;
            lastSubStep = subStep;
        }
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                lastompletedGlassCStep: lastStep,
                lastCompletedGlassSubStep: lastSubStep
            }
        });
    }
}

export const setNextGlassStep = (step: number, subStep: 1) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                nextGlassStep: step,
                nextGlassSubStep: subStep
            }
        });
    }
}

export const setStep = (step: number, subStep: number = 1) => {
    return async (dispatch, getState) => {
        var currentStep = getState().claimSubmit.fnolStepConfiguration.steps.filter(x => x.step === step)[0];
        if (isMobile) {
            if (currentStep.maxMobileSubSteps < subStep) {
                currentStep.subStep = currentStep.maxMobileSubSteps;
                subStep = currentStep.maxMobileSubSteps;
            }
            else {
                currentStep.subStep = subStep;
            }
        }
        else {
            if (currentStep.maxSubSteps < subStep) {
                currentStep.subStep = currentStep.maxSubSteps;
                subStep = currentStep.maxSubSteps;
            }
            else {
                currentStep.subStep = subStep;
            }
        }
        await dispatch(setClaimStep(currentStep));
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                fnolStep: step,
                fnolSubStep: subStep,
            }
        });
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                showMobileProfile: false,
            }
        });
    }
}

//duplicated to reduce confusion on authActions and not break claims
export const setStepClaim = (step: number, subStep: number = 1) => {
    return async (dispatch, getState) => {
        var currentStep = getState().claimSubmit.fnolStepConfiguration.steps.filter(x => x.step === step)[0];
        if (isMobile) {
            if (currentStep.maxMobileSubSteps < subStep) {
                currentStep.subStep = currentStep.maxMobileSubSteps;
                subStep = currentStep.maxMobileSubSteps;
            }
            else {
                currentStep.subStep = subStep;
            }
        }
        else {
            if (currentStep.maxSubSteps < subStep) {
                currentStep.subStep = currentStep.maxSubSteps;
                subStep = currentStep.maxSubSteps;
            }
            else {
                currentStep.subStep = subStep;
            }
        }
        await dispatch(setClaimStep(currentStep));
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                fnolStep: step,
                fnolSubStep: subStep,
            }
        });
        await dispatch({
            type: SET_CUSTOMER_DATA, payload: {
                showMobileProfile: false,
            }
        });
    }
}

export const setClaimStep = (step: any) => {
    return async (dispatch) => {
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                selectedClaimStep: step
            }
        });
    }
}

export const completeStep = () => {
    return async (dispatch, getState) => {
        var step = getState().claimSubmit.selectedClaimStep.step;
        var subStep = getState().claimSubmit.selectedClaimStep.subStep;
        var lastStep = getState().claimSubmit.lastCompletedStep;
        var lastSubStep = getState().claimSubmit.lastCompletedSubStep;
        if (step + (subStep / 10) > lastStep + (lastSubStep / 10)) {
            lastStep = step;
            lastSubStep = subStep;
        }
        await dispatch({
            type: SET_CLAIM_DATA, payload: {
                lastCompletedStep: lastStep,
                lastCompletedSubStep: lastSubStep
            }
        });
    }
}

export const setNextStep = (step: number, subStep: 1) => {
    return async (dispatch) => {
        dispatch({
            type: SET_CLAIM_DATA, payload: {
                nextFnolStep: step,
                nextFnolSubStep: subStep
            }
        });
    }
}

export const handleNextStep = () => {
    window.scrollTo(0, 0);
    return async (dispatch, getState) => {
        await dispatch(completeStep());
        await dispatch(handleNextClaimStep());
    }
}

export const handleNextClaimStep = () => {
    window.scrollTo(0, 0);
    return async (dispatch, getState) => {
        var currentStep = getState().claimSubmit.selectedClaimStep;
        if ((!isMobile && currentStep.subStep < currentStep.maxSubSteps) || (isMobile && currentStep.subStep < currentStep.maxMobileSubSteps)) {
            currentStep.subStep++;
        }
        else if ((!isMobile && (currentStep.subStep >= currentStep.maxSubSteps || currentStep.maxSubSteps === 0)) || (isMobile && ((currentStep.subStep >= currentStep.maxMobileSubSteps || currentStep.maxMobileSubSteps === 0)))) {
            for (var i = 0; i < getState().claimSubmit.fnolStepConfiguration.steps.length; i++) {
                if (getState().claimSubmit.fnolStepConfiguration.steps[i].step === currentStep.step) {
                    currentStep = getState().claimSubmit.fnolStepConfiguration.steps[i + 1];
                    break;
                }
            }
        }
        if (((isMobile && currentStep.maxMobileSubSteps === 0) || (!isMobile && currentStep.maxSubSteps === 0)) && (currentStep.title !== 'Complete' && currentStep.title !== 'Finalise details')) {
            await dispatch(setClaimStep(currentStep));
            dispatch(handleNextClaimStep());
        }
        else {
            dispatch(setClaimStep(currentStep));
        }
    }
}

export const handlePreviousClaimStep = () => {
    return async (dispatch, getState) => {
        var currentStep = getState().claimSubmit.selectedClaimStep;
        window.scrollTo(0, 0);
        if (currentStep.subStep > 1) {
            currentStep.subStep--;
            await dispatch(setClaimStep(currentStep));
        }
        else if (currentStep.subStep === 1 || (currentStep.subStep === 0 && currentStep.maxSubSteps === 0)) {
            var previousStep = getState().claimSubmit.fnolStepConfiguration.steps[getState().claimSubmit.fnolStepConfiguration.steps.indexOf(getState().claimSubmit.fnolStepConfiguration.steps.filter(x => x.step === (currentStep.step))[0]) - 1]
            previousStep = (previousStep) ? previousStep : currentStep;
            previousStep.subStep = !isMobile ? previousStep.maxSubSteps : previousStep.maxMobileSubSteps;
            if ((!isMobile && previousStep.maxSubSteps === 0) || (isMobile && previousStep.maxMobileSubSteps === 0)) {
                await dispatch(setClaimStep(previousStep));
                await dispatch(handlePreviousClaimStep());
            } else {
                await dispatch(setClaimStep(previousStep));
            }
        }
    }
}

export const handleNextGlassStep = () => {
    window.scrollTo(0, 0);
    return async (dispatch, getState) => {
        let nextStep = getState().claimSubmit.glassStep;
        let nextSubStep = getState().claimSubmit.glassSubStep;
        let currentStep = getState().claimSubmit.glassStep;
        if ((getState().claimSubmit.glassStepConfiguration.steps[currentStep - 1].maxSubSteps <= getState().claimSubmit.glassSubStep && !isMobile) || (getState().claimSubmit.glassStepConfiguration.steps[currentStep - 1].maxMobileSubSteps <= getState().claimSubmit.glassSubStep && isMobile)) {

            nextSubStep = 1;
            nextStep++;
        }
        else {
            nextSubStep++;
        }
        if ((getState().claimSubmit.glassStepConfiguration.steps[nextStep - 1].maxMobileSubSteps == 0 && isMobile)) {
            while ((getState().claimSubmit.glassStepConfiguration.steps[nextStep - 1].maxMobileSubSteps == 0 && isMobile)) {
                nextStep++;
                if (nextStep > 50) {
                    break;
                }
            }
        }
        if ((getState().claimSubmit.glassStepConfiguration.steps[nextStep - 1].maxSubSteps == 0 && !isMobile)) {
            while ((getState().claimSubmit.glassStepConfiguration.steps[nextStep - 1].maxSubSteps == 0 && !isMobile)) {
                nextStep++;
                if (nextStep > 50) {
                    break;
                }
            }
        }
        dispatch(completeGlassStep());
        dispatch(setGlassStep(nextStep, nextSubStep));
    }
}

export const handleStepBack = () => {
    return async (dispatch, getState) => {
        window.scrollTo(0, 0);
        dispatch(handlePreviousClaimStep());
    }
}

export const handleGlassStepBack = () => {
    window.scrollTo(0, 0);
    return async (dispatch, getState) => {
        let nextStep = getState().claimSubmit.glassStep;
        let nextSubStep = getState().claimSubmit.glassSubStep;
        let currentStep = getState().claimSubmit.glassStep;
        if (nextSubStep === 1) {
            nextSubStep = (!isMobile ? getState().claimSubmit.glassStepConfiguration.steps[currentStep - 2].maxSubSteps : getState().claimSubmit.glassStepConfiguration.steps[currentStep - 2].maxMobileSubSteps);
            nextStep--;
        }
        else {
            nextSubStep--;
        }
        dispatch(setGlassStep(nextStep, nextSubStep));
        if (nextSubStep === 0) {
            handleGlassStepBack();
        }
    }
}
//#endregion

//#region Warranty Claims

export const submitWarrantyClaim = () => {
    return async (dispatch, getState) => {
        dispatch({ type: LOADING_SCREEN_SHOW });
        logEvent('SSP_submit_warranty_claim', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        await postToController(dispatch, 'SubmitVapClaim', JSON.stringify({
            policyId: getState().profile.policyId,
            policyRiskItemId: getState().claimSubmit.selectedRiskItem.riskItems[0].id,
            incidentDate: getState().claimSubmit.incidentDate,
            incidentTime: getState().claimSubmit.time,
            claimTemplate: CLAIM_WARRANTY_TEMPLATE_ID
        })).then(async (response) => {
            if (response !== null && !response.documentSent) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            }
            else if (response.documentSent) {
                dispatch(handleNextStep());
            }
        }).catch((err) => {
            logErrorToDatabase("Error post SubmitGeneralClaim, Error: " + err);
            dispatch(navigateTo(DASHBOARD));

            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        }).finally(() => {
            dispatch({ type: LOADING_SCREEN_HIDE });
        });
    }
}

//#endregion

//#region Vap Claims

export const submitVapClaim = () => {
    return async (dispatch, getState) => {
        dispatch({ type: LOADING_SCREEN_SHOW });
        logEvent('SSP_submit_Vap_claim', getState().profile.selectedPersonalPolicy.id + '/' + getState().claimSubmit.selectedRiskItem.id);
        let claimTemplateId = CLAIM_SCRATCH_AND_DENT_TEMPLATE_ID;
        switch (getState().claimSubmit.incidentType.id) {
            case CAR_CLAIM_VAPS_TYRE_AND_RIM_ID:
                claimTemplateId = CLAIM_TYRE_AND_RIM_TEMPLATE_ID;
                break;
            case CAR_CLAIM_VAPS_DINGS_AND_THINGS_ID:
                claimTemplateId = CLAIM_LITTLE_DINGS_TEMPLATE_ID;
                break;
            default:
                break;
        }
        await postToController(dispatch, 'SubmitVapClaim', JSON.stringify({
            policyId: getState().profile.policyId,
            policyRiskItemId: getState().claimSubmit.selectedRiskItem.riskItems[0].id,
            incidentDate: getState().claimSubmit.incidentDate,
            incidentTime: getState().claimSubmit.time,
            claimTemplate: claimTemplateId
        })).then(async (response) => {
            if (response !== null && !response.documentSent) {
                dispatch({
                    type: MODAL_SHOW,
                    modalProps: {
                        type: MODAL_TYPE_ERROR,
                        header: ERROR_HEADER,
                        body: ERROR_SOMETHING_WENT_WRONG,
                    }
                });
                dispatch(navigateTo(DASHBOARD));
            }
            else if (response.documentSent) {
                dispatch(handleNextStep());
            }
        }).catch((err) => {
            logErrorToDatabase("Error post SubmitGeneralClaim, Error: " + err);
            dispatch(navigateTo(DASHBOARD));

            dispatch({
                type: MODAL_SHOW,
                modalProps: {
                    type: MODAL_TYPE_ERROR,
                    header: ERROR_HEADER,
                    body: ERROR_SOMETHING_WENT_WRONG,
                }
            });
        }).finally(() => {
            dispatch({ type: LOADING_SCREEN_HIDE });
        });
    }
}

//#endregion

//#region Helper Methods

export const getIncidentTypesByProductId = (productId) => {
    return async (dispatch) => {
        let typeList: any = [];
        await postToController(dispatch, 'GetIncidentTypesByProductId', JSON.stringify({ Parameter: productId })
        ).then(async response => {
            if (response && response !== "Failure") {
                typeList = response
            }
            else throw new Error("Error post GetIncidentTypesByProductId > response Failure");
        })
            .catch(err => {
                logErrorToDatabase("Error post GetIncidentTypesByProductId, Error: " + err);
            })
        return typeList;
    }
}

export const getQuoteIncidentTypesByRiskItemType = (riskItemType) => {
    return async (dispatch) => {
        let typeList: any = [];
        await postToController(dispatch, 'GetQuoteIncidentTypesByRiskItemType', JSON.stringify({ Parameter: riskItemType })
        ).then(async response => {
            if (response && response !== "Failure") {
                typeList = response
            }
            else throw new Error("Error post GetIncidentTypesByProductId > response Failure");
        })
            .catch(err => {
                logErrorToDatabase("Error post GetIncidentTypesByProductId, Error: " + err);
            })
        return typeList;
    }
}
//#endregion